import React, { useMemo } from "react";
export function SvgComponent({
  width = "24",
  height = "24",
  iconName,
  className,
  fill,
  style,
  id = "",
}) {
  const color1 = "#" + window.usuario?.Compania?.Color1 ?? 'rgb(241, 97, 1)';
  const selectIcon = (iconName) => {
    switch (iconName?.toLowerCase()) {
      case "click":
        return (
            <svg xmlns="http://www.w3.org/2000/svg" 
                 height={height} 
                 viewBox="0 -960 960 960" 
                 width={width}
                 className={className}
                 style={style}
                 fill={fill ? fill : color1}>
              <path
                  d="M80-480v-80h120v80H80Zm136 222-56-58 84-84 58 56-86 86Zm28-382-84-84 56-58 86 86-58 56Zm476 480L530-350l-50 150-120-400 400 120-148 52 188 188-80 80ZM400-720v-120h80v120h-80Zm236 80-58-56 86-86 56 56-84 86Z"/>
            </svg>
        )

      case "circulo":
        return (
            <svg xmlns="http://www.w3.org/2000/svg"
                 width={width}
                 fill={fill ? fill : color1}
                 height={height}
                 className={className}
                 style={style}
                 viewBox="0 -960 960 960">
            <path xmlns="http://www.w3.org/2000/svg" d="M480.07-220q-108.61 0-184.34-75.66Q220-371.31 220-479.93q0-108.61 75.66-184.34Q371.31-740 479.93-740q108.61 0 184.34 75.66Q740-588.69 740-480.07q0 108.61-75.66 184.34Q588.69-220 480.07-220Z"/>
            </svg>         
        )
      case "balance":
        return (
            <svg xmlns="http://www.w3.org/2000/svg"
                 width={width}
                 fill={fill ? fill : color1}
                 height={height}
                 className={className}
                 style={style}
                 viewBox="0 -960 960 960">
              <path xmlns="http://www.w3.org/2000/svg" d="M100-140v-60h350v-444.69q-27.15-7.08-47.5-26.85-20.35-19.77-27.81-48.46H242.31L360-435.77q-1.15 45-39.08 76.54Q283-327.69 230-327.69t-90.92-31.54q-37.92-31.54-39.08-76.54L217.69-720H140v-60h234.69q9.31-34.23 38.19-57.11Q441.77-860 480-860q38.23 0 67.12 22.89Q576-814.23 585.31-780H820v60h-77.69L860-435.77q-1.16 45-39.08 76.54Q783-327.69 730-327.69t-90.92-31.54q-37.93-31.54-39.08-76.54L717.69-720H585.31q-7.46 28.69-27.81 48.46-20.35 19.77-47.5 26.85V-200h350v60H100Zm552.31-297.69h155.38L730-625.15l-77.69 187.46Zm-500 0h155.38L230-625.15l-77.69 187.46ZM480-700q20.85 0 35.42-14.58Q530-729.15 530-750t-14.58-35.42Q500.85-800 480-800t-35.42 14.58Q430-770.85 430-750t14.58 35.42Q459.15-700 480-700Z"/>
            </svg>
        )

      case "manufacturing":
        return (
            <svg xmlns="http://www.w3.org/2000/svg"
                 width={width}
                 fill={fill ? fill : color1}
                 height={height}
                 className={className}
                 style={style}
                 viewBox="0 -960 960 960">
              <path xmlns="http://www.w3.org/2000/svg" d="m234-480-12-60q-12-5-22.5-10.5T178-564l-58 18-40-68 46-40q-2-13-2-26t2-26l-46-40 40-68 58 18q11-8 21.5-13.5T222-820l12-60h80l12 60q12 5 22.5 10.5T370-796l58-18 40 68-46 40q2 13 2 26t-2 26l46 40-40 68-58-18q-11 8-21.5 13.5T326-540l-12 60h-80Zm40-120q33 0 56.5-23.5T354-680q0-33-23.5-56.5T274-760q-33 0-56.5 23.5T194-680q0 33 23.5 56.5T274-600ZM592-40l-18-84q-17-6-31.5-14.5T514-158l-80 26-56-96 64-56q-2-18-2-36t2-36l-64-56 56-96 80 26q14-11 28.5-19.5T574-516l18-84h112l18 84q17 6 31.5 14.5T782-482l80-26 56 96-64 56q2 18 2 36t-2 36l64 56-56 96-80-26q-14 11-28.5 19.5T722-124l-18 84H592Zm56-160q50 0 85-35t35-85q0-50-35-85t-85-35q-50 0-85 35t-35 85q0 50 35 85t85 35Z"/>
            </svg>
        )
      
      case "referidos":
        return (
            <svg xmlns="http://www.w3.org/2000/svg"
                 width={width}
                 fill={fill ? fill : color1}
                 height={height}
                 className={className}
                 style={style}
                 viewBox="0 -960 960 960">
              <path xmlns="http://www.w3.org/2000/svg" d="M720-400v-120H600v-80h120v-120h80v120h120v80H800v120h-80Zm-360-80q-66 0-113-47t-47-113q0-66 47-113t113-47q66 0 113 47t47 113q0 66-47 113t-113 47ZM40-160v-112q0-34 17.5-62.5T104-378q62-31 126-46.5T360-440q66 0 130 15.5T616-378q29 15 46.5 43.5T680-272v112H40Zm80-80h480v-32q0-11-5.5-20T580-306q-54-27-109-40.5T360-360q-56 0-111 13.5T140-306q-9 5-14.5 14t-5.5 20v32Zm240-320q33 0 56.5-23.5T440-640q0-33-23.5-56.5T360-720q-33 0-56.5 23.5T280-640q0 33 23.5 56.5T360-560Zm0-80Zm0 400Z"/>
            </svg>     
        )
      
      case "credit-card":
          return (
              <svg xmlns="http://www.w3.org/2000/svg"
                   width={width}
                   fill={fill ? fill : color1}
                   height={height}
                   className={className}
                   style={style}
                   viewBox="0 -960 960 960">
                <path xmlns="http://www.w3.org/2000/svg" d="M886.22-737.85v515.7q0 27.6-20.34 47.86-20.33 20.27-48.03 20.27h-675.7q-27.6 0-47.86-20.27-20.27-20.26-20.27-47.86v-515.7q0-27.7 20.27-48.03 20.26-20.34 47.86-20.34h675.7q27.7 0 48.03 20.34 20.34 20.33 20.34 48.03ZM142.15-631.48h675.7v-106.37h-675.7v106.37Zm0 129v280.33h675.7v-280.33h-675.7Zm0 280.33v-515.7 515.7Z"/>
              </svg>
          )
      
      case "angel-up":
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width={width}
                fill={fill ? fill : color1}
                height={height}
                className={className}
                style={style}
                viewBox="0 0 24 24"
            >
              <path d="M0 16.67l2.829 2.83 9.175-9.339 9.167 9.339 2.829-2.83-11.996-12.17z" />
            </svg>
        );

      case "angel-down":
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width={width}
                fill={fill ? fill : color1}
                height={height}
                className={className}
                style={style}
                viewBox="0 0 24 24"
            >
              <path d="M0 7.33l2.829-2.83 9.175 9.339 9.167-9.339 2.829 2.83-11.996 12.17z" />
            </svg>
        );
      case "pin":
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width={width}
                height={height}
                className={className}
                fill={fill ? fill : color1}
                style={style}
                viewBox="0 -960 960 960"
            >
              <path xmlns="http://www.w3.org/2000/svg" d="m615.537-448 75.999 69.307v45.384H502.692v220.614L480-90.004l-22.692-22.691v-220.614H268.464v-45.384L340.001-448v-326.615h-47.307v-45.384h370.151v45.384h-47.308V-448Zm-285.69 69.307h295.845l-55.538-52.692v-343.23H385.385v343.23l-55.538 52.692Zm147.922 0Z"/>
            </svg>
        );
      
      case "unpin":
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width={width}
                height={height}
                className={className}
                fill={fill ? fill : color1}
                style={style}
                viewBox="0 -960 960 960"
            >
              <path xmlns="http://www.w3.org/2000/svg" d="M648.23-819.999v45.384h-32.693v355.92l-45.383-45.383v-310.537H385.385v125.768l-44.614-44.614 3.846-77.308h-37.308v-49.23H648.23ZM480-90.004l-22.692-22.691v-220.614H268.464v-45.384L340.001-448v-90.924L84.618-794.307l31.999-31.615 698.996 699.996-31.614 32L544.616-333.31h-41.924v220.614L480-90.004ZM329.847-378.693h170.154L385-492.925l.385 61.54-55.538 52.692Zm147.922-177.77ZM385-492.925Z"/>
            </svg>
        );
      
      case "back":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            className={className}
            fill={fill ? fill : color1}
            style={style}
            viewBox="0 0 24 24"
          >
            <path
              d="m9.474 5.209s-4.501 4.505-6.254 6.259c-.147.146-.22.338-.22.53s.073.384.22.53c1.752 1.754 6.252 6.257 6.252 6.257.145.145.336.217.527.217.191-.001.383-.074.53-.221.293-.293.294-.766.004-1.057l-4.976-4.976h14.692c.414 0 .75-.336.75-.75s-.336-.75-.75-.75h-14.692l4.978-4.979c.289-.289.287-.761-.006-1.054-.147-.147-.339-.221-.53-.221-.191-.001-.38.071-.525.215z"
              fillRule="nonzero"
            />
          </svg>
        );
      case "mi cuenta":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            fill={fill ? fill : color1}
            height={height}
            className={className}
            style={style}
            viewBox="0 -960 960 960"
          >
            <path xmlns="http://www.w3.org/2000/svg" d="M232.001-253.077q59.923-41.307 119.23-64.038Q410.539-339.846 480-339.846q69.461 0 129.077 22.731 59.615 22.731 119.538 64.038 43.615-50.538 64.807-106.725Q814.615-415.989 814.615-480q0-141.538-96.538-238.077Q621.538-814.615 480-814.615t-238.077 96.538Q145.385-621.538 145.385-480q0 64.011 21.5 120.198t65.116 106.725Zm247.782-204.231q-53.937 0-90.744-37.025-36.808-37.024-36.808-90.961 0-53.936 37.025-90.744 37.024-36.807 90.961-36.807t90.744 37.024q36.808 37.024 36.808 90.961t-37.025 90.744q-37.024 36.808-90.961 36.808Zm.685 357.307q-79.006 0-148.242-29.77-69.235-29.769-120.961-81.576-51.725-51.808-81.494-120.727-29.77-68.92-29.77-148t29.77-147.925q29.769-68.846 81.576-120.654 51.808-51.807 120.727-81.576 68.92-29.77 148-29.77t147.925 29.77q68.846 29.769 120.654 81.576 51.807 51.808 81.576 120.686 29.77 68.878 29.77 147.499 0 79.006-29.77 148.242-29.769 69.235-81.576 120.961-51.808 51.725-120.686 81.494-68.878 29.77-147.499 29.77ZM480-145.385q55.769 0 110-17.731t102.154-57.346q-47.923-35.231-101.5-54.616Q537.077-294.462 480-294.462T369.154-275.27q-53.77 19.192-100.923 54.808Q315.769-180.847 370-163.116q54.231 17.731 110 17.731Zm.054-357.307q35.869 0 59.1-23.284 23.231-23.285 23.231-59.154 0-35.87-23.285-59.101-23.284-23.231-59.154-23.231-35.869 0-59.1 23.285-23.231 23.284-23.231 59.154 0 35.869 23.285 59.1 23.284 23.231 59.154 23.231ZM480-585.077Zm0 365.153Z"/>
            </svg>
        );  
      case "iniciar sesion":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            fill={fill ? fill : color1}
            height={height}
            className={className}
            style={style}
            viewBox="0 -960 960 960"
          >
            <path xmlns="http://www.w3.org/2000/svg" d="M480.231-140.001v-45.384h282.075q4.616 0 8.463-3.846 3.846-3.847 3.846-8.463v-564.612q0-4.616-3.846-8.463-3.847-3.846-8.463-3.846H480.231v-45.384h282.075q23.529 0 40.611 17.082 17.082 17.082 17.082 40.611v564.612q0 23.529-17.082 40.611-17.082 17.082-40.611 17.082H480.231Zm-35.768-187.693-32.999-32.23 97.384-97.384H140.001v-45.384h367.616l-97.384-97.384 32.615-32.615 153.306 153.499-151.691 151.498Z"/>
            </svg>
        );  
      case "cancelar":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            fill={fill ? fill : color1}
            height={height}
            className={className}
            style={style}
            viewBox="0 -960 960 960"
          >
            <path xmlns="http://www.w3.org/2000/svg" d="M331.539-299.539 480-448.001l148.461 148.462 32-32L511.999-480l148.462-148.461-32-32L480-511.999 331.539-660.461l-32 32L448.001-480 299.539-331.539l32 32Zm148.528 199.538q-78.221 0-147.397-29.92-69.176-29.92-120.989-81.71-51.814-51.791-81.747-120.936-29.933-69.146-29.933-147.366 0-78.836 29.92-148.204 29.92-69.369 81.71-120.682 51.791-51.314 120.936-81.247 69.146-29.933 147.366-29.933 78.836 0 148.204 29.92 69.369 29.92 120.682 81.21 51.314 51.291 81.247 120.629 29.933 69.337 29.933 148.173 0 78.221-29.92 147.397-29.92 69.176-81.21 120.989-51.291 51.814-120.629 81.747-69.337 29.933-148.173 29.933ZM480-145.385q139.692 0 237.154-97.769Q814.615-340.923 814.615-480q0-139.692-97.461-237.154Q619.692-814.615 480-814.615q-139.077 0-236.846 97.461Q145.385-619.692 145.385-480q0 139.077 97.769 236.846T480-145.385ZM480-480Z"/>
            </svg>
        );      
      case "e-ncf":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            fill={fill ? fill : color1}
            height={height}
            className={className}
            style={style}
            viewBox="0 -960 960 960"
          >
            <path
              xmlns="http://www.w3.org/2000/svg"
              d="M520-120v-80h80v80h-80Zm-80-80v-200h80v200h-80Zm320-120v-160h80v160h-80Zm-80-160v-80h80v80h-80Zm-480 80v-80h80v80h-80Zm-80-80v-80h80v80h-80Zm360-280v-80h80v80h-80ZM180-660h120v-120H180v120Zm-60 60v-240h240v240H120Zm60 420h120v-120H180v120Zm-60 60v-240h240v240H120Zm540-540h120v-120H660v120Zm-60 60v-240h240v240H600Zm80 480v-120h-80v-80h160v120h80v80H680ZM520-400v-80h160v80H520Zm-160 0v-80h-80v-80h240v80h-80v80h-80Zm40-200v-160h80v80h80v80H400Zm-190-90v-60h60v60h-60Zm0 480v-60h60v60h-60Zm480-480v-60h60v60h-60Z"
            />
          </svg>
        );
      case "cardnet":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            fill={fill ? fill : color1}
            height={height}
            className={className}
            style={style}
            viewBox="0 -960 960 960"
          >
            <path
              xmlns="http://www.w3.org/2000/svg"
              d="M828-688v416q0 26-17 43t-43 17H192q-26 0-43-17t-17-43v-416q0-26 17-43t43-17h576q26 0 43 17t17 43Zm-668 90h640v-90q0-12-10-22t-22-10H192q-12 0-22 10t-10 22v90Zm0 76v250q0 12 10 22t22 10h576q12 0 22-10t10-22v-250H160Zm0 282v-480 480Z"
            />
          </svg>
        );
      case "terminal pos":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            fill={fill ? fill : color1}
            height={height}
            className={className}
            style={style}
            viewBox="0 -960 960 960"
          >
            <path
              xmlns="http://www.w3.org/2000/svg"
              d="M404.616-166.924h150.768v-35.384H404.616v35.384ZM292.309-60.001q-30.308 0-51.308-21t-21-51.308v-695.382q0-30.308 21-51.308t51.308-21h375.382q30.308 0 51.308 21t21 51.308v695.382q0 30.308-21 51.308t-51.308 21H292.309ZM280-249.231v116.922q0 4.616 3.846 8.463 3.847 3.846 8.463 3.846h375.382q4.616 0 8.463-3.846 3.846-3.847 3.846-8.463v-116.922H280Zm0-59.999h400v-420.771H280v420.771Zm0-480.769h400v-37.692q0-4.616-3.846-8.463-3.847-3.846-8.463-3.846H292.309q-4.616 0-8.463 3.846-3.846 3.847-3.846 8.463v37.692Zm0 540.768V-120v-129.231Zm0-540.768V-840v50.001Z"
            />
          </svg>
        );
      case "consulta":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            fill={fill ? fill : color1}
            height={height}
            className={className}
            style={style}
            viewBox="0 -960 960 960"
          >
            <path xmlns="http://www.w3.org/2000/svg" d="M539.281-100.001q-99.872 0-170.153-70.038-70.28-70.039-70.28-169.961v-21.846q-81-10.538-135.5-72.23-54.5-61.692-54.5-145.923v-229.999h120v-40h59.999v139.999h-59.999v-40h-60.001v170q0 66 47 113t113 47q66 0 113-47t47-113v-170h-60.002v40h-59.998v-139.999h59.998v40h120v229.999q0 84.231-54.499 145.923-54.5 61.692-135.5 72.23V-340q0 75 52.612 127.5T539.231-160q75 0 127.5-52.5t52.5-127.5v-64.692q-31.538-9.308-51.923-36.269-20.384-26.961-20.384-61.345 0-42.628 29.852-72.467 29.853-29.84 72.499-29.84 42.647 0 72.454 29.84 29.807 29.839 29.807 72.467 0 34.384-20.384 61.345-20.385 26.961-51.923 36.269V-340q0 99.922-70.038 169.961-70.038 70.038-169.91 70.038ZM749.23-459.999q17.769 0 30.039-12.269 12.269-12.269 12.269-30.038 0-17.77-12.269-30.039-12.27-12.269-30.039-12.269-17.769 0-30.039 12.269-12.269 12.269-12.269 30.039 0 17.769 12.269 30.038 12.27 12.269 30.039 12.269Zm0-42.307Z"/>
            </svg>
        );
      case "consultas":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            fill={fill ? fill : color1}
            height={height}
            className={className}
            style={style}
            viewBox="0 -960 960 960"
          >
            <path xmlns="http://www.w3.org/2000/svg" d="M539.281-100.001q-99.872 0-170.153-70.038-70.28-70.039-70.28-169.961v-21.846q-81-10.538-135.5-72.23-54.5-61.692-54.5-145.923v-229.999h120v-40h59.999v139.999h-59.999v-40h-60.001v170q0 66 47 113t113 47q66 0 113-47t47-113v-170h-60.002v40h-59.998v-139.999h59.998v40h120v229.999q0 84.231-54.499 145.923-54.5 61.692-135.5 72.23V-340q0 75 52.612 127.5T539.231-160q75 0 127.5-52.5t52.5-127.5v-64.692q-31.538-9.308-51.923-36.269-20.384-26.961-20.384-61.345 0-42.628 29.852-72.467 29.853-29.84 72.499-29.84 42.647 0 72.454 29.84 29.807 29.839 29.807 72.467 0 34.384-20.384 61.345-20.385 26.961-51.923 36.269V-340q0 99.922-70.038 169.961-70.038 70.038-169.91 70.038ZM749.23-459.999q17.769 0 30.039-12.269 12.269-12.269 12.269-30.038 0-17.77-12.269-30.039-12.27-12.269-30.039-12.269-17.769 0-30.039 12.269-12.269 12.269-12.269 30.039 0 17.769 12.269 30.038 12.27 12.269 30.039 12.269Zm0-42.307Z"/>
            </svg>
        );
      case "administración":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            fill={fill ? fill : color1}
            height={height}
            className={className}
            style={style}
            viewBox="0 -960 960 960"
          >
            <path xmlns="http://www.w3.org/2000/svg" d="M400-492.309q-57.749 0-98.874-41.124-41.125-41.125-41.125-98.874 0-57.75 41.125-98.874 41.125-41.125 98.874-41.125 57.749 0 98.874 41.125 41.125 41.124 41.125 98.874 0 57.749-41.125 98.874-41.125 41.124-98.874 41.124ZM100.001-187.694v-88.922q0-30.307 15.462-54.884 15.461-24.576 43.153-38.038 49.847-24.846 107.692-41.5Q324.154-427.691 400-427.691h11.692q4.846 0 10.462 1.23-6.077 14.154-10.039 28.846-3.961 14.692-6.576 29.922H400q-69.077 0-122.307 15.885-53.231 15.884-91.539 35.807-13.615 7.308-19.885 17.077-6.269 9.77-6.269 22.308v28.923h252q4.461 15.23 11.577 30.922 7.115 15.692 15.653 29.077H100.001Zm544.23 29.614-8.923-53.076q-14.308-4.231-26.923-11.077-12.616-6.846-24-17.154l-50.692 17.615-28.461-48.383 41.384-33.846q-4.307-15.538-4.307-30.615 0-15.078 4.307-30.616l-40.999-34.615 28.461-48.383 50.307 18q11-10.308 23.808-16.962 12.807-6.654 27.115-10.885l8.923-53.076h56.921l8.539 53.076q14.308 4.231 27.115 11.193 12.808 6.961 23.808 17.884l50.307-19.23 28.461 49.614-41 34.615q4.308 14.429 4.308 30.061 0 15.631-4.308 29.939l41.385 33.846-28.461 48.383-50.692-17.615q-11.384 10.308-24 17.154-12.615 6.846-26.923 11.077l-8.539 53.076h-56.921Zm28.11-100.383q31.428 0 53.774-22.38t22.346-53.807q0-31.428-22.38-53.774t-53.808-22.346q-31.427 0-53.773 22.38-22.346 22.38-22.346 53.808 0 31.427 22.38 53.773 22.38 22.346 53.807 22.346ZM400-552.307q33 0 56.5-23.5t23.5-56.5q0-33-23.5-56.5t-56.5-23.5q-33 0-56.5 23.5t-23.5 56.5q0 33 23.5 56.5t56.5 23.5Zm0-80Zm12 384.614Z"/>
            </svg>
        );
      case "minus":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            fill={fill ? fill : color1}
            height={height}
            className={className}
            style={style}
            viewBox="0 -960 960 960"
          >
            <path
              xmlns="http://www.w3.org/2000/svg"
              d="M220.001-457.308v-45.384h519.998v45.384H220.001Z"
            />
          </svg>
        );
      case "plus":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            fill={fill ? fill : color1}
            height={height}
            className={className}
            style={style}
            viewBox="0 -960 960 960"
          >
            <path
              xmlns="http://www.w3.org/2000/svg"
              d="M457.308-457.308H220.001v-45.384h237.307v-237.307h45.384v237.307h237.307v45.384H502.692v237.307h-45.384v-237.307Z"
            />
          </svg>
        );
      case "x":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            fill={fill ? fill : color1}
            height={height}
            className={className}
            style={style}
            viewBox="0 -960 960 960"
          >
            <path d="m250.923-218.924-31.999-31.999L448.001-480 218.924-709.077l31.999-31.999L480-511.999l229.077-229.077 31.999 31.999L511.999-480l229.077 229.077-31.999 31.999L480-448.001 250.923-218.924Z" />
          </svg>
        );
      case "formalizar":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            fill={fill ? fill : color1}
            height={height}
            className={className}
            style={style}
            viewBox="0 -960 960 960"
          >
            <path d="M367.693-641.539v-45.383h344.614v45.383H367.693Zm0 115.385v-45.384h344.614v45.384H367.693Zm123.845 380.769H185.385h306.153Zm0 45.384H229.231q-37.211 0-63.22-26.01-26.01-26.009-26.01-63.22v-126.153h120v-544.615h559.998v352.921q-11.731-.846-23.101.697t-22.283 5.15v-313.384h-469.23v499.231H570.46l-45.384 45.383H185.385v80.77q0 18.635 12.668 31.24 12.668 12.606 30.178 12.606h263.307v45.384Zm73.078 0v-105.692l217.153-216.153q7.462-7.461 16.154-10.5 8.692-3.038 17.384-3.038 9.308 0 18.192 3.538 8.885 3.539 15.961 10.615l37 37.385q7.077 7.461 10.308 16.153 3.231 8.693 3.231 17.385 0 8.692-3.731 17.692t-10.333 16.461L670.307-100.001H564.616Zm287.691-250.307-37-37.385 37 37.385Zm-240 202.615h38l129.847-130.462-18.385-19-18.615-18.769-130.847 130.231v38Zm149.462-149.462-18.615-18.769 37 37.769-18.385-19Z" />
          </svg>
        );
      case "crm":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            fill={fill ? fill : color1}
            height={height}
            className={className}
            style={style}
            viewBox="0 -960 960 960"
          >
            <path d="m348.538-190.463-32.615-32.615 85.001-85.616q-127.923-15-214.423-61.192t-86.5-114.575q0-70.923 110.923-121.807T480-657.152q158.769 0 269.384 50.884 110.615 50.884 110.615 121.807 0 50.537-58.808 91.691-58.807 41.154-156.73 64.23v-48.845Q723.692-397 769.154-428.423q45.461-31.423 45.461-56.038 0-33.154-84.077-80.231Q646.461-611.769 480-611.769q-165.846 0-250.23 47.077-84.385 47.077-84.385 80.231 0 41.538 63.462 75.384 63.462 33.846 196.231 57l-89.155-87.924 32.615-32.614 141.076 140.46-141.076 141.692Z" />
          </svg>
        );
      case "incidentes":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            fill={fill ? fill : color1}
            height={height}
            className={className}
            style={style}
            viewBox="0 -960 960 960"
          >
            <path d="M74.618-140.001 480-839.997l405.382 699.996H74.618Zm78.613-45.384h653.538L480-749.23 153.231-185.385Zm329.797-60.077q10.703 0 17.76-7.24 7.058-7.24 7.058-17.942t-7.24-17.76q-7.24-7.057-17.942-7.057t-17.76 7.239q-7.058 7.24-7.058 17.942 0 10.703 7.24 17.76 7.24 7.058 17.942 7.058Zm-22.874-97.922h45.384V-561.23h-45.384v217.846ZM480-467.307Z" />
          </svg>
        );
      case "mis solicitudes":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            fill={fill ? fill : color1}
            height={height}
            className={className}
            style={style}
            viewBox="0 -960 960 960"
          >
            <path d="M307.72-293.693q11.588 0 19.819-8.258 8.231-8.257 8.231-19.846 0-11.588-8.258-19.819-8.258-8.23-19.846-8.23-11.588 0-19.819 8.257-8.231 8.258-8.231 19.846 0 11.589 8.258 19.819 8.258 8.231 19.846 8.231Zm0-158.23q11.588 0 19.819-8.258t8.231-19.846q0-11.588-8.258-19.819t-19.846-8.231q-11.588 0-19.819 8.258t-8.231 19.846q0 11.588 8.258 19.819t19.846 8.231Zm0-158.231q11.588 0 19.819-8.257 8.231-8.258 8.231-19.846 0-11.589-8.258-19.819-8.258-8.231-19.846-8.231-11.588 0-19.819 8.258-8.231 8.257-8.231 19.846 0 11.588 8.258 19.819 8.258 8.23 19.846 8.23Zm130.434 311.076h230.538v-45.383H438.154v45.383Zm0-158.23h230.538v-45.384H438.154v45.384Zm0-158.231h230.538v-45.383H438.154v45.383Zm-240.46 475.538q-23.529 0-40.611-17.082-17.082-17.082-17.082-40.611v-564.612q0-23.529 17.082-40.611 17.082-17.082 40.611-17.082h564.612q23.529 0 40.611 17.082 17.082 17.082 17.082 40.611v564.612q0 23.529-17.082 40.611-17.082 17.082-40.611 17.082H197.694Zm0-45.384h564.612q4.616 0 8.463-3.846 3.846-3.847 3.846-8.463v-564.612q0-4.616-3.846-8.463-3.847-3.846-8.463-3.846H197.694q-4.616 0-8.463 3.846-3.846 3.847-3.846 8.463v564.612q0 4.616 3.846 8.463 3.847 3.846 8.463 3.846Zm-12.309-589.23V-185.385-774.615Z" />
          </svg>
        );
      case "youtube":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            fill={fill ? fill : color1}
            height={height}
            className={className}
            style={style}
            viewBox="0 0 196 144"
          >
            <g>
              <path d="M157.0235,0H38.9763C17.4843,0,0,17.5393,0,39.0977v65.8048C0,126.4609,17.4843,144,38.9763,144h118.0472   C178.5155,144,196,126.4609,196,104.9025V39.0977C196,17.5393,178.5155,0,157.0235,0z M188,104.9025   C188,122.0489,174.1035,136,157.0235,136H38.9763C21.8963,136,8,122.0489,8,104.9025V39.0977C8,21.9513,21.8963,8,38.9763,8   h118.0472C174.1035,8,188,21.9513,188,39.0977V104.9025z" />
              <path d="M133.4415,70.5529l-55.42-32.4612c-1.2304-0.7204-2.7655-0.7324-4.01-0.0192C72.7675,38.7853,72,40.1093,72,41.5429   v64.9144c0,1.4336,0.7675,2.7576,2.0095,3.4704c0.6172,0.3536,1.3048,0.5296,1.9905,0.5296c0.6991,0,1.3963-0.1836,2.0215-0.5488   l55.42-32.4532c1.2244-0.7168,1.9785-2.0313,1.9785-3.4513C135.42,72.584,134.668,71.2697,133.4415,70.5529z M80,99.4785V48.5217   l43.504,25.4823L80,99.4785z" />
            </g>
          </svg>
        );
      case "whatsapp":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            fill={fill ? fill : color1}
            height={height}
            className={className}
            style={style}
            viewBox="0 0 24 24"
          >
            <g id="whatsapp">
              <g data-name="<Group>" id="_Group_">
                <path
                  d="M12,.5A11.5,11.5,0,0,0,2.46,18.42L.5,23.5l5.23-1.87A11.5,11.5,0,1,0,12,.5Z"
                  data-name="<Path>"
                  id="_Path_"
                  style={{
                    fill: "none",
                    stroke: "#77777A",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                  }}
                />
                <path
                  d="M9.5,14.5c1.3,1.3,4.17,3,5.5,3a2.53,2.53,0,0,0,2.5-2v-1s-1.23-.6-2-1-2,1-2,1A6.52,6.52,0,0,1,11,13a6.52,6.52,0,0,1-1.5-2.5s1.4-1.23,1-2-1-2-1-2h-1A2.53,2.53,0,0,0,6.5,9C6.5,10.33,8.2,13.2,9.5,14.5Z"
                  data-name="<Path>"
                  id="_Path_2"
                  style={{
                    fill: "none",
                    stroke: "#77777A",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                  }}
                />
              </g>
            </g>
          </svg>
        );
      case "registrar entrada":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            fill={fill ? fill : color1}
            height={height}
            className={className}
            style={style}
            viewBox="0 -960 960 960"
          >
            <path d="M196.155-100.001q-21.885 0-39.019-17.248-17.135-17.247-17.135-39.291v-494.613q0-22.043 17.135-39.291 17.134-17.247 39.019-17.247h67.692v-176.922h432.69v176.922h67.308q22.231 0 39.192 17.247 16.962 17.248 16.962 39.291v494.613q0 22.044-16.962 39.291-16.961 17.248-39.192 17.248h-567.69Zm113.076-607.69h341.923v-131.538H309.231v131.538ZM196.155-145.385h567.69q4.231 0 7.501-3.462 3.269-3.462 3.269-7.693v-494.613q0-4.231-3.269-7.693-3.27-3.462-7.501-3.462h-567.69q-4.231 0-7.501 3.462-3.269 3.462-3.269 7.693v494.613q0 4.231 3.269 7.693 3.27 3.462 7.501 3.462Zm283.447-73.847q76.769 0 131.083-54.121 54.314-54.121 54.314-130.354 0-76.393-54.367-130.766-54.367-54.373-131.136-54.373-76.45 0-130.28 54.374-53.831 54.373-53.831 130.691 0 76.319 53.884 130.434 53.883 54.115 130.333 54.115Zm.177-39.614q-60.164 0-102.279-42.164-42.115-42.164-42.115-102.308 0-60.144 42.097-102.644 42.098-42.5 102.017-42.5 60.237 0 102.869 42.45Q625-463.563 625-403.419q0 60.144-42.529 102.358-42.529 42.215-102.692 42.215Zm44.682-75.616L549-359l-51.693-52.077v-88.154h-34.614v102.615l61.768 62.154ZM480-403.846Z" />
          </svg>
        );
      case "cerrar sesion":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            fill={fill ? fill : color1}
            height={height}
            className={className}
            style={style}
            viewBox="0 -960 960 960"
          >
            <path d="M197.694-140.001q-23.529 0-40.611-17.082-17.082-17.082-17.082-40.611v-564.612q0-23.529 17.082-40.611 17.082-17.082 40.611-17.082h282.075v45.384H197.694q-4.616 0-8.463 3.846-3.846 3.847-3.846 8.463v564.612q0 4.616 3.846 8.463 3.847 3.846 8.463 3.846h282.075v45.384H197.694Zm470.614-187.693-32.999-32.23 97.384-97.384H363.846v-45.384h367.616l-97.384-97.384 32.615-32.615 153.306 153.499-151.691 151.498Z" />
          </svg>
        );
      case "incidente":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            fill={fill ? fill : color1}
            height={height}
            className={className}
            style={style}
            viewBox="0 -960 960 960"
          >
            <path d="M74.618-140.001 480-839.997l405.382 699.996H74.618Zm78.613-45.384h653.538L480-749.23 153.231-185.385Zm329.797-60.077q10.703 0 17.76-7.24 7.058-7.24 7.058-17.942t-7.24-17.76q-7.24-7.057-17.942-7.057t-17.76 7.239q-7.058 7.24-7.058 17.942 0 10.703 7.24 17.76 7.24 7.058 17.942 7.058Zm-22.874-97.922h45.384V-561.23h-45.384v217.846ZM480-467.307Z" />
          </svg>
        );
      case "cambio compania":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            fill={fill ? fill : color1}
            height={height}
            viewBox="0 -960 960 960"
          >
            <path d="m379.539-248.155 33-32.615-89.001-88.615H520v-45.384H323.538l89.001-88.616-33-32.614-143.922 143.922 143.922 143.922Zm200.922-170.154 143.922-143.922-143.307-143.922-33.23 32.615 88.616 88.616H440v45.383h196.462l-88.616 88.616 32.615 32.614ZM480.067-100.001q-78.221 0-147.397-29.92-69.176-29.92-120.989-81.71-51.814-51.791-81.747-120.936-29.933-69.146-29.933-147.366 0-78.836 29.92-148.204 29.92-69.369 81.71-120.682 51.791-51.314 120.936-81.247 69.146-29.933 147.366-29.933 78.836 0 148.204 29.92 69.369 29.92 120.682 81.21 51.314 51.291 81.247 120.629 29.933 69.337 29.933 148.173 0 78.221-29.92 147.397-29.92 69.176-81.21 120.989-51.291 51.814-120.629 81.747-69.337 29.933-148.173 29.933ZM480-145.385q139.692 0 237.154-97.769Q814.615-340.923 814.615-480q0-139.692-97.461-237.154Q619.692-814.615 480-814.615q-139.077 0-236.846 97.461Q145.385-619.692 145.385-480q0 139.077 97.769 236.846T480-145.385ZM480-480Z" />
          </svg>
        );
      case "configuracion":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            fill={fill ? fill : color1}
            height={height}
            className={className}
            style={style}
            viewBox="0 -960 960 960"
          >
            <path d="m400.693-100.001-18.077-120.231q-20.538-7-44.231-20.346-23.692-13.346-40.846-28.27l-111.846 50.923-79.922-141.306 101.077-74.384q-2-10.539-2.885-23-.885-12.462-.885-23 0-10.154.885-22.616t2.885-24.154l-101.077-74.769 79.922-140.152 111.461 50.154q18.308-14.924 41.231-28.078 22.924-13.154 43.847-19.538l18.461-121.231h158.614l18.077 120.615q22.077 8.154 44.154 20.231 22.077 12.077 39.769 28.001l113.384-50.154 79.538 140.152-102.615 74.308q2.769 11.923 3.462 24 .692 12.077.692 22.846 0 10.385-.885 22.154-.884 11.769-3.269 24.462l102.23 74.153-79.922 141.306-112.615-51.307q-18.692 15.692-40.346 28.962-21.654 13.269-43.577 19.654l-18.077 120.615H400.693Zm36.461-45.384h85.307L536.846-257q31.846-8 59.423-23.846 27.577-15.847 52.731-40.231l104.461 45.231 40-70.847L701-414.923q4-17.77 6.307-33.5 2.308-15.731 2.308-31.577 0-16.615-2-31.961T701-544.307l93.23-69-40-70.847-105.615 45.231q-21.077-23.692-50.846-41.769Q568-698.769 536.461-703l-13.615-111.615h-85.692l-13.231 111.231q-33.23 6.615-61.192 22.653-27.961 16.039-52.115 41.424L205.77-684.154l-40 70.847 92.461 67.846q-4.385 15.846-6.692 32.153-2.308 16.308-2.308 33.693 0 16.615 2.308 32.538 2.307 15.923 6.307 32.154l-92.076 68.23 40 70.847 104.461-44.847q24 24.385 52.154 40.231 28.154 15.846 61.154 23.846l13.615 111.231Zm41.692-221.924q47.076 0 79.884-32.807 32.807-32.808 32.807-79.884t-32.807-79.884q-32.808-32.807-79.884-32.807-46.692 0-79.691 32.807-33 32.808-33 79.884t33 79.884q32.999 32.807 79.691 32.807ZM480-480Z" />
          </svg>
        );
      case "refresh":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            fill={fill ? fill : color1}
            height={height}
            className={className}
            style={style}
            viewBox="0 -960 960 960"
          >
            <path d="M481.662-180.001q-124.748 0-212.435-87.67-87.687-87.669-87.687-212.268t87.687-212.329q87.687-87.731 212.312-87.731 81.922 0 145.153 35.654 63.231 35.654 106.384 97.578v-133.232h45.384v225.537H552.924v-45.384h157.999q-36.077-60.769-94.692-97.769-58.616-37-134.692-37-106.757 0-180.686 73.916t-73.929 180.654q0 106.737 73.971 180.699 73.971 73.961 180.787 73.961 81.318 0 148.395-46.538 67.077-46.539 93.692-123h46.999q-27.846 96.922-107.964 155.922-80.117 59-181.142 59Z" />
          </svg>
        );
      case "cambiar contrasena":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            fill={fill ? fill : color1}
            height={height}
            className={className}
            style={style}
            viewBox="0 -960 960 960"
          >
            <path d="M520-137.155q-64.384 0-125.153-24.077-60.769-24.077-106.846-66.384l32.615-32.615Q361-224 412.193-203.27 463.385-182.539 520-182.539q123.077 0 210.269-87.384Q817.461-357.308 817.461-480t-87.384-210.077Q642.692-777.461 520-777.461t-210.077 87.384Q222.539-602.692 222.539-480v39.155l77.308-77.308 31.615 31.615-131.615 131.999-132-131.999 32-31.615 77.308 77.693V-480q0-71.414 26.769-133.745 26.77-62.331 73.385-108.946 46.615-46.615 108.939-73.385 62.324-26.769 133.73-26.769 71.406 0 133.752 26.769 62.346 26.77 108.961 73.385 46.615 46.615 73.385 108.935 26.769 62.32 26.769 133.721 0 143.188-99.782 243.034T520-137.155Zm-80-191.307q-14.173 0-24.01-9.836-9.836-9.837-9.836-24.01v-120q0-14.173 11.5-24.202 11.5-10.029 28.5-10.029v-45.769q0-30.433 21.707-52.332 21.706-21.899 52.139-21.899 30.433 0 52.332 21.899t21.899 52.332v45.769q16.615 0 28.307 10.029 11.693 10.029 11.693 24.202v120q0 14.173-10.029 24.01-10.029 9.836-24.202 9.836H440Zm34.231-188.077h91.923v-45.62q0-19.534-13.385-32.918-13.384-13.385-32.769-13.385-19.385 0-32.577 13.385-13.192 13.384-13.192 32.918v45.62Z" />
          </svg>
        );
      case "submenu":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            fill={fill ? fill : color1}
            height={height}
            className={className}
            style={style}
            viewBox="0 -960 960 960"
          >
            <path d="M331.462-216.155 480-305.539l148.538 90.384-39.308-169.153 130.692-113.461L547.538-513 480-672.153 412.462-514l-172.384 15.231L370.77-384.923l-39.308 168.768Zm-68.46 94.613 57.307-246.766L128.85-534.23l252.613-21.922L480-788.842l98.537 232.69L831.15-534.23 639.691-368.308l57.307 246.766L480-252.463 263.002-121.542ZM480-433.846Z" />
          </svg>
        );
      case "seguridad":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            fill={fill ? fill : color1}
            height={height}
            className={className}
            style={style}
            viewBox="0 -960 960 960"
          >
            <path d="M480-100.771q-130.384-35.384-215.191-154.807Q180.001-375 180.001-520.461v-225.692L480-858.46l299.999 112.307v225.692q0 145.461-84.808 264.883Q610.384-136.155 480-100.771Zm0-46.999q103.307-33.846 171.846-125.999Q720.384-365.923 732-480H480v-329.23l-254.615 94.692v194.077q0 11.23.5 19.73T228-480h252v332.23Z" />
          </svg>
        );
      case "activos fijos" || "activos fijos (beta)":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            fill={fill ? fill : color1}
            height={height}
            className={className}
            style={style}
            viewBox="0 -960 960 960"
          >
            <path d="M411.846-126.233v-224.22l55.846-163.471q1.615-5.077 5.692-8.346t12.769-3.269h297.231q7.741 0 11.986 2.961 4.244 2.962 6.475 8.654l55.846 163.471v224.22q0 8.125-5.207 13.332-5.207 5.207-13.239 5.207h-13.21q-7.468 0-12.828-5.207-5.361-5.207-5.361-13.332v-50.385H461.691v50.385q0 8.125-5.389 13.332-5.388 5.207-13.292 5.207h-12.882q-7.56 0-12.921-5.207t-5.361-13.332Zm44.923-251.615h355.999l-38.384-114.615H495.153l-38.384 114.615Zm-11.847 33.077v135.077-135.077Zm66.616 103.692q15.757 0 26.417-10.66 10.66-10.659 10.66-26.417 0-15.209-10.66-25.951-10.66-10.741-26.417-10.741-15.758 0-26.417 10.741-10.66 10.742-10.66 26.144 0 15.401 10.66 26.143 10.659 10.741 26.417 10.741Zm246.461 0q15.209 0 26.143-10.66 10.934-10.659 10.934-26.417 0-15.209-10.934-25.951-10.934-10.741-26.335-10.741-15.402 0-26.144 10.741-10.741 10.742-10.741 26.144 0 15.401 10.66 26.143 10.659 10.741 26.417 10.741ZM246.924-418.771v-65.692h65.691v65.692h-65.691ZM431.999-652.77v-65.691h65.692v65.691h-65.692ZM246.924-263.233v-65.692h65.691v65.692h-65.691Zm0 155.539v-65.692h65.691v65.692h-65.691Zm-144.615 0v-521.384h185.076v-233.998h354.92v233.845h-45.384v-188.461H332.768v233.998H147.693v476h-45.384Zm342.613-102h379.692v-135.077H444.922v135.077Z" />
          </svg>
        );
      case "alertas":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            fill={fill ? fill : color1}
            height={height}
            className={className}
            style={style}
            viewBox="0 -960 960 960"
          >
            <path d="M180.001-204.616v-45.383h72.308v-315.924q0-81.241 49.307-144.889 49.308-63.649 128.385-78.918v-20.269q0-20.833 14.57-35.416 14.57-14.584 35.384-14.584t35.429 14.584q14.615 14.583 14.615 35.416v20.461q79.077 15.077 128.385 78.726 49.307 63.648 49.307 144.889v315.924h72.308v45.383H180.001ZM480-499.307Zm-.068 406.998q-29.855 0-51.047-21.24-21.192-21.24-21.192-51.067h144.614q0 29.923-21.26 51.115-21.26 21.192-51.115 21.192Zm-182.24-157.69h364.616v-315.924q0-75.77-53.269-129.039-53.27-53.269-129.039-53.269-75.769 0-129.039 53.269-53.269 53.269-53.269 129.039v315.924Z" />
          </svg>
        );
      case "banco":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            fill={fill ? fill : color1}
            height={height}
            className={className}
            style={style}
            viewBox="0 -960 960 960"
          >
            <path d="M238.925-251.385v-343.231h45.384v343.231h-45.384Zm221.229 0v-343.231h45.384v343.231h-45.384ZM110.771-140.617V-186h738.458v45.383H110.771Zm564.92-110.768v-343.231h45.384v343.231h-45.384Zm-564.92-408.616v-37.23L480-898.306l369.229 201.075v37.23H110.771Zm109.768-45.384h518.922-518.922Zm0 0h518.922L480-846.23 220.539-705.385Z" />
          </svg>
        );
      case "bancos":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            fill={fill ? fill : color1}
            height={height}
            className={className}
            style={style}
            viewBox="0 -960 960 960"
          >
            <path d="M238.925-251.385v-343.231h45.384v343.231h-45.384Zm221.229 0v-343.231h45.384v343.231h-45.384ZM110.771-140.617V-186h738.458v45.383H110.771Zm564.92-110.768v-343.231h45.384v343.231h-45.384Zm-564.92-408.616v-37.23L480-898.306l369.229 201.075v37.23H110.771Zm109.768-45.384h518.922-518.922Zm0 0h518.922L480-846.23 220.539-705.385Z" />
          </svg>
        );
      case "administracion":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            fill={fill ? fill : color1}
            height={height}
            className={className}
            style={style}
            viewBox="0 -960 960 960"
          >
            <path d="M480-100.771q-130.384-35.384-215.191-154.807Q180.001-375 180.001-520.461v-225.692L480-858.46l299.999 112.307v225.692q0 145.461-84.808 264.883Q610.384-136.155 480-100.771Zm0-46.999q103.307-33.846 171.846-125.999Q720.384-365.923 732-480H480v-329.23l-254.615 94.692v194.077q0 11.23.5 19.73T228-480h252v332.23Z" />
          </svg>
        );
      case "contabilidad":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            fill={fill ? fill : color1}
            height={height}
            className={className}
            style={style}
            viewBox="0 -960 960 960"
          >
            <path d="M227-100.001q-37.211 0-63.22-26.01-26.009-26.009-26.009-63.039v-103.641h125.077v-559.615l55.261 47.692 56.03-47.692 56.031 47.692 56.03-47.692 56.031 47.692 56.153-47.692 56.154 47.692 56.153-47.692 56.154 47.692 55.384-47.692v663.075q0 37.211-26.009 63.22-26.009 26.01-63.22 26.01H227Zm506.192-45.384q19.038 0 31.346-12.308 12.308-12.307 12.308-31.538v-585.384H308.231v481.924h381.307v103.46q0 19.231 12.308 31.538 12.308 12.308 31.346 12.308Zm-367.73-480.846v-45.384h226.922v45.384H365.462Zm0 130.538v-45.383h226.922v45.383H365.462ZM685-620.846q-11.231 0-19.654-8.423t-8.423-19.654q0-11.231 8.423-19.654T685-677q11.23 0 19.653 8.423 8.423 8.423 8.423 19.654t-8.423 19.654q-8.423 8.423-19.653 8.423Zm0 126.692q-11.231 0-19.654-8.423t-8.423-19.654q0-11.23 8.423-19.653 8.423-8.423 19.654-8.423 11.23 0 19.653 8.423 8.423 8.423 8.423 19.653 0 11.231-8.423 19.654T685-494.154ZM226.111-145.385h418.044v-101.922H183.154v58.076q0 19.231 12.458 31.538 12.458 12.308 30.499 12.308Zm-42.957 0v-101.922 101.922Z" />
          </svg>
        );
      case "cuentas por pagar":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            fill={fill ? fill : color1}
            height={height}
            className={className}
            style={style}
            viewBox="0 -960 960 960"
          >
            <path d="M535.384-436.924q-41.922 0-70.96-29.038-29.038-29.038-29.038-70.961 0-41.922 29.038-70.96 29.038-29.038 70.96-29.038 41.923 0 70.961 29.038 29.038 29.038 29.038 70.96 0 41.923-29.038 70.961-29.038 29.038-70.961 29.038ZM242.309-298.463q-23.5 0-40.596-17.096-17.096-17.096-17.096-40.596v-361.536q0-23.5 17.096-40.596 17.096-17.096 40.596-17.096h586.15q23.5 0 40.596 17.096 17.096 17.096 17.096 40.596v361.536q0 23.5-17.096 40.596-17.096 17.096-40.596 17.096h-586.15Zm74.614-45.383h436.923q0-36.231 25.394-61.577 25.394-25.346 61.528-25.346v-212.308q-36.231 0-61.576-25.394-25.346-25.394-25.346-61.528H316.923q0 36.23-25.394 61.576-25.394 25.346-61.528 25.346v212.308q36.23 0 61.576 25.394 25.346 25.394 25.346 61.529Zm449.998 156.152h-635.38q-23.5 0-40.596-17.096-17.096-17.097-17.096-40.596v-410.766h45.383v410.766q0 4.615 3.847 8.462 3.846 3.846 8.462 3.846h635.38v45.384ZM242.309-343.846h-12.308v-386.153h12.308q-5 0-8.654 3.654t-3.654 8.654v361.536q0 5 3.654 8.654 3.654 3.655 8.654 3.655Z" />
          </svg>
        );
      case "inventario":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            fill={fill ? fill : color1}
            height={height}
            className={className}
            style={style}
            viewBox="0 -960 960 960"
          >
            <path d="M197.694-100.001q-23.596 0-40.645-17.048-17.048-17.049-17.048-40.645v-471.46q-17-5.231-28.5-20.43t-11.5-35.032v-117.69q0-23.596 17.048-40.645 17.049-17.048 40.645-17.048h644.612q23.596 0 40.645 17.048 17.048 17.049 17.048 40.645v117.69q0 19.833-11.5 35.032-11.5 15.199-28.5 20.43v471.46q0 23.596-17.048 40.645-17.049 17.048-40.645 17.048H197.694Zm-12.309-526.923v467.307q0 6.154 4.423 10.193 4.424 4.039 10.963 4.039h561.535q5.385 0 8.847-3.462 3.462-3.462 3.462-8.847v-469.23h-589.23Zm-27.691-45.383h644.612q5.385 0 8.847-3.462 3.462-3.462 3.462-8.847v-117.69q0-5.385-3.462-8.847-3.462-3.462-8.847-3.462H157.694q-5.385 0-8.847 3.462-3.462 3.462-3.462 8.847v117.69q0 5.385 3.462 8.847 3.462 3.462 8.847 3.462Zm209.999 234.998h224.614V-480H367.693v42.691ZM480-386.154Z" />
          </svg>
        );
      case "impuestos":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            fill={fill ? fill : color1}
            height={height}
            className={className}
            style={style}
            viewBox="0 -960 960 960"
          >
            <path d="M464.232-215.616h45.383v-40h64.616q9.663 0 16.178-6.515 6.514-6.514 6.514-16.177v-127.308q0-9.663-6.514-16.177-6.515-6.514-16.178-6.514H422.308v-81.924h174.615v-45.384h-87.308v-40h-45.383v40h-64.616q-9.663 0-16.177 6.514-6.515 6.515-6.515 16.178v127.307q0 9.664 6.515 16.178 6.514 6.514 16.177 6.514h151.923V-301H376.924v45.384h87.308v40ZM237.694-100.001q-23.529 0-40.611-17.082-17.082-17.082-17.082-40.611v-644.612q0-23.529 17.082-40.611 17.082-17.082 40.611-17.082h347.537l194.768 194.768v507.537q0 23.529-17.082 40.611-17.082 17.082-40.611 17.082H237.694Zm310.23-559.845v-154.769h-310.23q-4.616 0-8.463 3.846-3.846 3.847-3.846 8.463v644.612q0 4.616 3.846 8.463 3.847 3.846 8.463 3.846h484.612q4.616 0 8.463-3.846 3.846-3.847 3.846-8.463v-502.152H547.924ZM225.385-814.615v154.769-154.769 669.23V-814.615Z" />
          </svg>
        );
      case "facturación":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            fill={fill ? fill : color1}
            height={height}
            className={className}
            style={style}
            viewBox="0 -960 960 960"
          >
            <path d="M283.224-626.538q-23.741 0-40.789-17.096-17.049-17.096-17.049-40.596v-102.691q0-23.5 17.097-40.596 17.096-17.096 40.596-17.096h393.697q23.741 0 40.789 17.096 17.049 17.096 17.049 40.596v102.691q0 23.5-17.097 40.596-17.096 17.096-40.596 17.096H283.224Zm-.145-45.384h393.842q5.77 0 9.04-3.269 3.269-3.27 3.269-9.039v-102.691q0-5.769-3.269-9.039-3.27-3.269-9.04-3.269H283.079q-5.77 0-9.04 3.269-3.269 3.27-3.269 9.039v102.691q0 5.769 3.269 9.039 3.27 3.269 9.04 3.269Zm-110 556.535q-23.5 0-40.596-17.096-17.096-17.096-17.096-40.596v-61.923h729.226v61.923q0 23.596-17.096 40.644t-40.596 17.048H173.079Zm-57.692-147.692 128.391-295.766q7.3-15.77 21.61-25.385 14.31-9.616 30.536-9.616h368.152q16.226 0 30.536 9.616 14.31 9.615 21.61 25.385l128.391 295.766H115.387Zm229.229-72.307h40q7.077 0 12.384-5.307 5.308-5.308 5.308-12.385T397-365.462q-5.307-5.308-12.384-5.308h-40q-7.077 0-12.385 5.308-5.307 5.307-5.307 12.384t5.307 12.385q5.308 5.307 12.385 5.307Zm0-75.384h40q7.077 0 12.384-5.308 5.308-5.307 5.308-12.384T397-440.847q-5.307-5.307-12.384-5.307h-40q-7.077 0-12.385 5.307-5.307 5.308-5.307 12.385t5.307 12.384q5.308 5.308 12.385 5.308Zm0-75.384h40q7.077 0 12.384-5.308 5.308-5.308 5.308-12.384 0-7.077-5.308-12.385-5.307-5.308-12.384-5.308h-40q-7.077 0-12.385 5.308-5.307 5.308-5.307 12.385 0 7.076 5.307 12.384 5.308 5.308 12.385 5.308ZM460-335.386h40q7.077 0 12.385-5.307 5.307-5.308 5.307-12.385t-5.307-12.384q-5.308-5.308-12.385-5.308h-40q-7.077 0-12.384 5.308-5.308 5.307-5.308 12.384t5.308 12.385q5.307 5.307 12.384 5.307Zm0-75.384h40q7.077 0 12.385-5.308 5.307-5.307 5.307-12.384t-5.307-12.385q-5.308-5.307-12.385-5.307h-40q-7.077 0-12.384 5.307-5.308 5.308-5.308 12.385t5.308 12.384q5.307 5.308 12.384 5.308Zm0-75.384h40q7.077 0 12.385-5.308 5.307-5.308 5.307-12.384 0-7.077-5.307-12.385-5.308-5.308-12.385-5.308h-40q-7.077 0-12.384 5.308-5.308 5.308-5.308 12.385 0 7.076 5.308 12.384 5.307 5.308 12.384 5.308Zm115.384 150.768h40q7.077 0 12.385-5.307 5.307-5.308 5.307-12.385t-5.307-12.384q-5.308-5.308-12.385-5.308h-40q-7.077 0-12.384 5.308-5.308 5.307-5.308 12.384T563-340.693q5.307 5.307 12.384 5.307Zm0-75.384h40q7.077 0 12.385-5.308 5.307-5.307 5.307-12.384t-5.307-12.385q-5.308-5.307-12.385-5.307h-40q-7.077 0-12.384 5.307-5.308 5.308-5.308 12.385T563-416.078q5.307 5.308 12.384 5.308Zm0-75.384h40q7.077 0 12.385-5.308 5.307-5.308 5.307-12.384 0-7.077-5.307-12.385-5.308-5.308-12.385-5.308h-40q-7.077 0-12.384 5.308-5.308 5.308-5.308 12.385 0 7.076 5.308 12.384 5.307 5.308 12.384 5.308Z" />
          </svg>
        );
      case "cuentas por cobrar":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            fill={fill ? fill : color1}
            height={height}
            className={className}
            style={style}
            viewBox="0 -960 960 960"
          >
            <path d="M100.001-220.001v-519.998h759.998v519.998H100.001Zm110-174.999h112.307q14.692 0 25.038-10.346 10.346-10.347 10.346-25.039v-70.769q0-13.057-10.654-22.297-10.653-9.241-24.73-9.241h-71.923v-56.923h107.307v-40.384H210.001v137.691h107.307v56.924H210.001V-395Zm238.154 66.845h303.69v-14.307q0-40-40.692-63.153Q670.461-428.769 600-428.769q-70.461 0-111.153 23.012-40.692 23.013-40.692 63.295v14.307ZM600-491.846q29.154 0 49.576-20.616 20.423-20.615 20.423-49.384 0-29.153-20.423-49.576-20.422-20.423-49.576-20.423t-49.576 20.423q-20.423 20.423-20.423 49.576 0 28.769 20.423 49.384 20.422 20.616 49.576 20.616ZM145.385-265.385h669.23v-429.23h-669.23v429.23Zm0 0v-429.23 429.23Z" />
          </svg>
        );
      case "cardnet":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            fill={fill ? fill : color1}
            height={height}
            className={className}
            style={style}
            viewBox="0 -960 960 960"
          >
            <path d="M480-100.771q-130.384-35.384-215.191-154.807Q180.001-375 180.001-520.461v-225.692L480-858.46l299.999 112.307v225.692q0 145.461-84.808 264.883Q610.384-136.155 480-100.771Zm0-46.999q103.307-33.846 171.846-125.999Q720.384-365.923 732-480H480v-329.23l-254.615 94.692v194.077q0 11.23.5 19.73T228-480h252v332.23Z" />
          </svg>
        );
      case "caja chica":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            fill={fill ? fill : color1}
            height={height}
            className={className}
            style={style}
            viewBox="0 -960 960 960"
          >
            <path d="M640-524.616q14.692 0 25.038-10.346T675.384-560q0-14.692-10.346-25.038T640-595.384q-14.692 0-25.038 10.346T604.616-560q0 14.692 10.346 25.038T640-524.616Zm-320-100h200v-45.383H320v45.383ZM195.001-140.001q-31.692-109.385-63.346-217.692Q100.001-466 100.001-580q0-83.538 58.231-141.768 58.23-58.231 141.768-58.231h210.001q27.461-36.076 65.884-58.038 38.423-21.962 84.115-21.962 16.538 0 28.268 11.731 11.731 11.73 11.731 28.268 0 4.077-1.116 8.154-1.115 4.076-2.346 7.538-5.538 14.462-9.423 29.616t-6.654 30.616l104.078 104.077h75.461v244.383L750.845-359.77l-65.846 219.769H500.001v-80H379.999v80H195.001Zm34.23-45.384h105.384v-80h210.77v80h105.769l62.615-208.846 100.846-34.615v-165.769h-48.923L634.615-725.692q.615-23.846 5.346-46t11.115-44.23q-35.307 9.23-65.845 29.115-30.538 19.885-47.769 52.192H300q-64.363 0-109.489 45.126Q145.385-644.362 145.385-580q0 101.835 28.423 198.994 28.423 97.16 55.423 195.621ZM480-500.846Z" />
          </svg>
        );
      case "finanzas":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            fill={fill ? fill : color1}
            height={height}
            className={className}
            style={style}
            viewBox="0 -960 960 960"
          >
            <path d="M297.463-287.77h45.383v-193.845h-45.383v193.845Zm319.691 0h45.383v-404.614h-45.383v404.614Zm-159.846 0h45.384v-108.769h-45.384v108.769Zm0-193.845h45.384V-547h-45.384v65.385ZM197.694-140.001q-23.529 0-40.611-17.082-17.082-17.082-17.082-40.611v-564.612q0-23.529 17.082-40.611 17.082-17.082 40.611-17.082h564.612q23.529 0 40.611 17.082 17.082 17.082 17.082 40.611v564.612q0 23.529-17.082 40.611-17.082 17.082-40.611 17.082H197.694Zm0-45.384h564.612q4.616 0 8.463-3.846 3.846-3.847 3.846-8.463v-564.612q0-4.616-3.846-8.463-3.847-3.846-8.463-3.846H197.694q-4.616 0-8.463 3.846-3.846 3.847-3.846 8.463v564.612q0 4.616 3.846 8.463 3.847 3.846 8.463 3.846Zm-12.309-589.23V-185.385-774.615Z" />
          </svg>
        );
      case "pronósticos de ventas":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            fill={fill ? fill : color1}
            height={height}
            className={className}
            style={style}
            viewBox="0 -960 960 960"
          >
            <path d="m132.616-258.078-32.615-32.615 271.23-270.998 165.076 165.076L785-643.769H649.538v-45.383h210.461v210.46H815.23v-131.847L535.692-330.616 370.615-495.693 132.616-258.078Z" />
          </svg>
        );
      case "pronósticos ventas":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            fill={fill ? fill : color1}
            height={height}
            className={className}
            style={style}
            viewBox="0 -960 960 960"
          >
            <path d="m132.616-258.078-32.615-32.615 271.23-270.998 165.076 165.076L785-643.769H649.538v-45.383h210.461v210.46H815.23v-131.847L535.692-330.616 370.615-495.693 132.616-258.078Z" />
          </svg>
        );
      case "pronóstico ventas":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            fill={fill ? fill : color1}
            height={height}
            className={className}
            style={style}
            viewBox="0 -960 960 960"
          >
            <path d="m132.616-258.078-32.615-32.615 271.23-270.998 165.076 165.076L785-643.769H649.538v-45.383h210.461v210.46H815.23v-131.847L535.692-330.616 370.615-495.693 132.616-258.078Z" />
          </svg>
        );
      case "importación":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            fill={fill ? fill : color1}
            height={height}
            className={className}
            style={style}
            viewBox="0 -960 960 960"
          >
            <path d="M480-410.693ZM171.77-220.771l-65.153-231.613q-3.231-10.846 1.5-21.192t14.808-13.577l57.076-19.616v-207.845q0-24.23 16.731-40.653t40.962-17.039h149.615v-120h185.382v120h149.615q23.981 0 40.837 16.856t16.856 40.836v208.461l57.692 19q9.846 3.231 15.346 13.077T854.921-453L788.23-220.771q-41.846-9.231-77.102-32.654-35.257-23.423-70.513-61.039-33.538 39.462-72.613 66.962-39.075 27.501-88.002 27.501-48.927 0-88.002-27.501-39.075-27.5-72.613-66.962-34.871 37.616-70.32 61.039-35.449 23.423-77.295 32.654ZM90-60.001v-45.384h70q42 0 83-13.096t77-37.289q36 24.385 77 36.385 41 12 83 12t83-12q41-12 77-36.385 36 24.385 77 37.385 41 13 83 13h69.999v45.384H800q-41.385 0-81.385-10.308-40-10.308-78.615-30.308-38.615 20-79.615 30.308-41 10.307-80.385 10.307-39.385 0-80.385-10.307-41-10.308-79.615-30.308-38.615 20-78.493 30.308-39.879 10.307-81.751 10.307H90.001Zm135.385-461.536L480-603.999l254.615 83.077v-193.692q0-5.385-3.462-8.846-3.462-3.462-8.847-3.462H237.694q-5.385 0-8.847 3.462-3.462 3.461-3.462 8.846v193.077Zm254.307 256.152q50.154 0 87.846-38.5T640-383.924q30.77 36.924 57.808 62.731 27.038 25.808 59.961 44.5l49.077-172.846L480-556 152.539-449.539l49.692 171.615q32.308-17.461 59.961-43.076 27.654-25.615 57.808-62.924 35.385 42.155 72.462 80.347 37.077 38.192 87.23 38.192Z" />
          </svg>
        );
      case "e-ncf":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            fill={fill ? fill : color1}
            height={height}
            className={className}
            style={style}
            viewBox="0 -960 960 960"
          >
            <path d="M480-100.771q-130.384-35.384-215.191-154.807Q180.001-375 180.001-520.461v-225.692L480-858.46l299.999 112.307v225.692q0 145.461-84.808 264.883Q610.384-136.155 480-100.771Zm0-46.999q103.307-33.846 171.846-125.999Q720.384-365.923 732-480H480v-329.23l-254.615 94.692v194.077q0 11.23.5 19.73T228-480h252v332.23Z" />
          </svg>
        );
      case "recursos humanos":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            fill={fill ? fill : color1}
            height={height}
            className={className}
            style={style}
            viewBox="0 -960 960 960"
          >
            <path d="M20.002-248.462v-41.461q0-36.644 39.769-60.283 39.769-23.64 103.683-23.64 10.242 0 21.087.693 10.844.692 21.844 2.344-6.846 16.194-10.461 32.472-3.615 16.279-3.615 33.337v56.538H20.001Zm239.999 0v-54.999q0-28.091 15.77-51.353 15.769-23.262 45.461-40.57 29.692-17.307 70.153-25.961 40.461-8.654 88.461-8.654 48.923 0 89.384 8.654t70.154 25.961q29.692 17.308 45.153 40.57 15.462 23.262 15.462 51.353v54.999H260.001Zm507.69 0v-56.423q0-17.969-3.115-34.234t-10.346-31.615q11.769-1.727 22.364-2.419 10.594-.693 20.713-.693 64.038 0 103.365 23.191t39.327 60.732v41.461H767.691ZM305-293.846h350v-8.692q1.154-36.616-47.231-59.346Q559.385-384.615 480-384.615q-79 0-127.577 22.731-48.577 22.73-47.423 59.961v8.077ZM162.543-405.384q-25.003 0-42.811-17.942-17.807-17.942-17.807-43.211 0-25.154 17.942-42.962 17.942-17.807 43.211-17.807 25.153 0 43.153 17.807 18 17.808 18 43.509 0 24.606-17.789 42.606-17.788 18-43.899 18Zm634.331 0q-24.721 0-42.721-18.063-17.999-18.062-17.999-42.976 0-25.268 18.062-43.076 18.062-17.807 43.165-17.807 25.464 0 43.271 17.807 17.808 17.808 17.808 43.394 0 24.962-17.759 42.841-17.76 17.88-43.827 17.88Zm-316.738-54.615q-43.212 0-73.597-30.288-30.384-30.288-30.384-73.557 0-44.134 30.288-73.989 30.288-29.855 73.557-29.855 44.134 0 73.99 29.816 29.855 29.816 29.855 73.893 0 43.212-29.816 73.596-29.817 30.384-73.893 30.384Zm.407-45.383q24.688 0 41.303-16.966 16.615-16.967 16.615-42.039 0-24.687-16.716-41.303-16.716-16.615-41.394-16.615-24.582 0-41.697 16.716-17.115 16.717-17.115 41.395 0 24.581 16.966 41.697 16.966 17.115 42.038 17.115ZM480-293.846Zm0-269.998Z" />
          </svg>
        );
      case "proyecto":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            fill={fill ? fill : color1}
            height={height}
            className={className}
            style={style}
            viewBox="0 -960 960 960"
          >
            <path d="M515.308-310.616 596-367.77l80.076 57.154-30.307-97.538 80.076-67.23h-97.368L596-571.307l-32.923 95.923h-97.922l80.461 67.23-30.308 97.538ZM157.694-180.001q-23.529 0-40.611-17.347-17.082-17.346-17.082-40.346v-484.612q0-23 17.082-40.346 17.082-17.347 40.611-17.347h249.459l65.385 65.385h329.768q23 0 40.346 17.347 17.347 17.346 17.347 40.346v419.227q0 23-17.347 40.346-17.346 17.347-40.346 17.347H157.694Zm0-45.384h644.612q5.385 0 8.847-3.462 3.462-3.462 3.462-8.847v-419.227q0-5.385-3.462-8.847-3.462-3.462-8.847-3.462H454.077l-65.385-65.385H157.694q-5.385 0-8.847 3.462-3.462 3.462-3.462 8.847v484.612q0 5.385 3.462 8.847 3.462 3.462 8.847 3.462Zm-12.309 0v-509.23V-225.385Z" />
          </svg>
        );
      case "proyectos":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            fill={fill ? fill : color1}
            height={height}
            className={className}
            style={style}
            viewBox="0 -960 960 960"
          >
            <path d="M515.308-310.616 596-367.77l80.076 57.154-30.307-97.538 80.076-67.23h-97.368L596-571.307l-32.923 95.923h-97.922l80.461 67.23-30.308 97.538ZM157.694-180.001q-23.529 0-40.611-17.347-17.082-17.346-17.082-40.346v-484.612q0-23 17.082-40.346 17.082-17.347 40.611-17.347h249.459l65.385 65.385h329.768q23 0 40.346 17.347 17.347 17.346 17.347 40.346v419.227q0 23-17.347 40.346-17.346 17.347-40.346 17.347H157.694Zm0-45.384h644.612q5.385 0 8.847-3.462 3.462-3.462 3.462-8.847v-419.227q0-5.385-3.462-8.847-3.462-3.462-8.847-3.462H454.077l-65.385-65.385H157.694q-5.385 0-8.847 3.462-3.462 3.462-3.462 8.847v484.612q0 5.385 3.462 8.847 3.462 3.462 8.847 3.462Zm-12.309 0v-509.23V-225.385Z" />
          </svg>
        );
      case "terminal pos":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            fill={fill ? fill : color1}
            height={height}
            className={className}
            style={style}
            viewBox="0 -960 960 960"
          >
            <path d="M480-100.771q-130.384-35.384-215.191-154.807Q180.001-375 180.001-520.461v-225.692L480-858.46l299.999 112.307v225.692q0 145.461-84.808 264.883Q610.384-136.155 480-100.771Zm0-46.999q103.307-33.846 171.846-125.999Q720.384-365.923 732-480H480v-329.23l-254.615 94.692v194.077q0 11.23.5 19.73T228-480h252v332.23Z" />
          </svg>
        );
      case "ayuda":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            fill={fill ? fill : color1}
            height={height}
            className={className}
            style={style}
            viewBox="0 -960 960 960"
          >
            <path d="M484.022-260.463q13.285 0 22.555-9.483 9.269-9.483 9.269-22.769 0-12.901-9.291-22.362-9.291-9.462-22.577-9.462-13.285 0-22.747 9.484-9.461 9.483-9.461 22.384 0 13.286 9.483 22.747t22.769 9.461ZM456.308-398h45.538q.384-24.462 7.654-44.039 7.269-19.576 37.038-44.884 29.846-26.384 42.461-49.846 12.616-23.461 12.616-51.663 0-49.413-32.346-79.875-32.345-30.461-83.654-30.461-44.384 0-78.614 22.769-34.231 22.769-50.462 59.615l41.846 16.153q11.384-26.846 32.423-41.769 21.038-14.923 51.807-14.923 36.693 0 57.308 20.039 20.616 20.038 20.616 49.423 0 21.615-12.231 40.154-12.231 18.538-35.308 38.384-29.23 26-42.961 51.308-13.731 25.308-13.731 59.615Zm23.759 297.999q-78.221 0-147.397-29.92-69.176-29.92-120.989-81.71-51.814-51.791-81.747-120.936-29.933-69.146-29.933-147.366 0-78.836 29.92-148.204 29.92-69.369 81.71-120.682 51.791-51.314 120.936-81.247 69.146-29.933 147.366-29.933 78.836 0 148.204 29.92 69.369 29.92 120.682 81.21 51.314 51.291 81.247 120.629 29.933 69.337 29.933 148.173 0 78.221-29.92 147.397-29.92 69.176-81.21 120.989-51.291 51.814-120.629 81.747-69.337 29.933-148.173 29.933ZM480-145.385q139.692 0 237.154-97.769Q814.615-340.923 814.615-480q0-139.692-97.461-237.154Q619.692-814.615 480-814.615q-139.077 0-236.846 97.461Q145.385-619.692 145.385-480q0 139.077 97.769 236.846T480-145.385ZM480-480Z" />
          </svg>
        );
      case "deal":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            fill={fill ? fill : color1}
            height={height}
            className={className}
            style={style}
            viewBox="0 0 24 24"
          >
            <path d="M11.362 2c4.156 0 2.638 6 2.638 6s6-1.65 6 2.457v11.543h-16v-20h7.362zm.827-2h-10.189v24h20v-14.386c0-2.391-6.648-9.614-9.811-9.614zm4.811 13h-10v-1h10v1zm0 2h-10v1h10v-1zm0 3h-10v1h10v-1z" />
          </svg>
        );

      case "single-note":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            fill={fill ? fill : color1}
            height={height}
            className={className}
            style={style}
            viewBox="0 0 24 24"
          >
            <path d="M4 22v-20h16v11.543c0 4.107-6 2.457-6 2.457s1.518 6-2.638 6h-7.362zm18-7.614v-14.386h-20v24h10.189c3.163 0 9.811-7.223 9.811-9.614z" />
          </svg>
        );

      case "notes":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            fill={fill ? fill : color1}
            height={height}
            className={className}
            style={style}
            viewBox="0 0 24 24"
          >
            <path d="M6 22v-16h16v7.543c0 4.107-6 2.457-6 2.457s1.518 6-2.638 6h-7.362zm18-7.614v-10.386h-20v20h10.189c3.163 0 9.811-7.223 9.811-9.614zm-2-11.386h-19v19h-1v-20h20v1zm-2-2h-19v19h-1v-20h20v1z" />
          </svg>
        );

      case "arrow-up-thin":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            fill={fill ? fill : color1}
            height={height}
            className={className}
            style={style}
            viewBox="0 0 24 24"
          >
            <path d="M11 2.206l-6.235 7.528-.765-.645 7.521-9 7.479 9-.764.646-6.236-7.53v21.884h-1v-21.883z" />
          </svg>
        );

      case "arrow-down-thin":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            fill={fill ? fill : color1}
            height={height}
            className={className}
            style={style}
            viewBox="0 0 24 24"
          >
            <path d="M11 21.883l-6.235-7.527-.765.644 7.521 9 7.479-9-.764-.645-6.236 7.529v-21.884h-1v21.883z" />
          </svg>
        );

      case "cancel":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            fill={fill ? fill : color1}
            height={height}
            className={className}
            style={style}
            viewBox="0 0 24 24"
          >
            <path d="M23 20.168l-8.185-8.187 8.185-8.174-2.832-2.807-8.182 8.179-8.176-8.179-2.81 2.81 8.186 8.196-8.186 8.184 2.81 2.81 8.203-8.192 8.18 8.192z" />
          </svg>
        );

      case "info":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className={className}
            style={style}
            viewBox="0 -960 960 960"
            width={width}
            fill={fill ? fill : color1}
            height={height}
          >
            <path
              xmlns="http://www.w3.org/2000/svg"
              d="M440-280h80v-240h-80v240Zm40-320q17 0 28.5-11.5T520-640q0-17-11.5-28.5T480-680q-17 0-28.5 11.5T440-640q0 17 11.5 28.5T480-600Zm0 520q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z"
            />
          </svg>
        );

      case "more-options-horizontal":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className={className}
            style={style}
            viewBox="0 -960 960 960"
            width={width}
            fill={fill ? fill : color1}
            height={height}
          >
            <path d="M240-400q-33 0-56.5-23.5T160-480q0-33 23.5-56.5T240-560q33 0 56.5 23.5T320-480q0 33-23.5 56.5T240-400Zm240 0q-33 0-56.5-23.5T400-480q0-33 23.5-56.5T480-560q33 0 56.5 23.5T560-480q0 33-23.5 56.5T480-400Zm240 0q-33 0-56.5-23.5T640-480q0-33 23.5-56.5T720-560q33 0 56.5 23.5T800-480q0 33-23.5 56.5T720-400Z" />
          </svg>
        );

      case "triangle-down":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            fill={fill ? fill : color1}
            height={height}
            className={className}
            style={style}
            viewBox="0 0 24 24"
          >
            <path d="M0 3l12 18 12-18h-24zm12 16.197l-10.132-15.197h20.263l-10.131 15.197" />
          </svg>
        );

      case "triangle-up":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            fill={fill ? fill : color1}
            height={height}
            className={className}
            style={style}
            viewBox="0 0 24 24"
          >
            <path d="M0 21l12-18 12 18h-24zm12-16.197l-10.132 15.197h20.263l-10.131-15.197" />
          </svg>
        );

      case "search-google-font":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            fill={fill ? fill : color1}
            height={height}
            className={className}
            style={style}
            viewBox="0 -960 960 960"
          >
            <path d="M784-120 532-372q-30 24-69 38t-83 14q-109 0-184.5-75.5T120-580q0-109 75.5-184.5T380-840q109 0 184.5 75.5T640-580q0 44-14 83t-38 69l252 252-56 56ZM380-400q75 0 127.5-52.5T560-580q0-75-52.5-127.5T380-760q-75 0-127.5 52.5T200-580q0 75 52.5 127.5T380-400Z" />
          </svg>
        );

      case "plus-google-font":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            fill={fill ? fill : color1}
            height={height}
            className={className}
            style={style}
            viewBox="0 -960 960 960"
          >
            <path d="M440-440H200v-80h240v-240h80v240h240v80H520v240h-80v-240Z" />
          </svg>
        );

      case "arrow-down":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            fill={fill ? fill : color1}
            height={height}
            className={className}
            style={style}
            viewBox="0 -960 960 960"
          >
            <path d="M480-344 240-584l56-56 184 184 184-184 56 56-240 240Z" />
          </svg>
        );

      case "arrow-right":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            fill={fill ? fill : color1}
            height={height}
            className={className}
            style={style}
            viewBox="0 -960 960 960"
          >
            <path d="M504-480 320-664l56-56 240 240-240 240-56-56 184-184Z" />
          </svg>
        );

      case "ventas":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            width={width}
            fill={fill ? fill : color1}
            height={height}
            className={className}
            style={style}
          >
            <path d="M6.72 20.492c1.532.956 3.342 1.508 5.28 1.508 1.934 0 3.741-.55 5.272-1.503l1.24 1.582c-1.876 1.215-4.112 1.921-6.512 1.921-2.403 0-4.642-.708-6.52-1.926l1.24-1.582zm-5.317-1.33h-1.403c0-1.104.895-2 2-2h2c.53 0 1.039.211 1.414.586s.586.884.586 1.414h-1.403c-.196-.606-.755-.726-1.597-.726s-1.4.115-1.597.726zm10.559-11.162c-3.037 0-5.5 2.462-5.5 5.5 0 3.037 2.463 5.5 5.5 5.5s5.5-2.463 5.5-5.5c0-3.038-2.463-5.5-5.5-5.5zm7.441 11h-1.403c0-1.105.895-2 2-2h2c.53 0 1.039.211 1.414.586s.586.883.586 1.414h-1.403c-.196-.606-.755-.726-1.597-.726s-1.4.115-1.597.726zm-7.441-9.5c2.346 0 4 1.654 4 4s-1.654 4-4 4-4-1.654-4-4 1.654-4 4-4zm-8.962 2.662c1.242 0 2.25 1.008 2.25 2.25s-1.008 2.25-2.25 2.25-2.25-1.008-2.25-2.25 1.008-2.25 2.25-2.25zm18-.162c1.242 0 2.25 1.008 2.25 2.25s-1.008 2.25-2.25 2.25-2.25-1.008-2.25-2.25 1.008-2.25 2.25-2.25zm-8.75-1.5v.509c.362.01.768.073 1.221.21l-.181.824c-.384-.135-.808-.257-1.221-.232-.745.043-.81.688-.291.958.856.402 1.972.7 1.972 1.772.001.859-.672 1.316-1.5 1.432v.527h-.5v-.499c-.518-.009-1.053-.133-1.5-.364l.227-.822c.478.186 1.114.383 1.613.27.574-.13.692-.721.057-1.005-.466-.217-1.889-.403-1.889-1.621 0-.682.519-1.292 1.492-1.425v-.534h.5zm-9.25 3.012c.497 0 .9.403.9.9s-.403.9-.9.9-.9-.403-.9-.9.403-.9.9-.9zm18-.162c.497 0 .9.403.9.9s-.403.9-.9.9-.9-.403-.9-.9.403-.9.9-.9zm-13-12.666v2.149c-2.938 1.285-5.141 3.942-5.798 7.158l-2.034-.003c.732-4.328 3.785-7.872 7.832-9.304zm8 0c4.047 1.432 7.1 4.976 7.832 9.304l-2.034.003c-.657-3.216-2.86-5.873-5.798-7.158v-2.149zm-5.597 6.316h-1.403c0-1.105.895-2 2-2h2c.53 0 1.039.211 1.414.586s.586.883.586 1.414h-1.403c-.196-.606-.755-.726-1.597-.726s-1.4.115-1.597.726zm1.597-7c1.242 0 2.25 1.008 2.25 2.25s-1.008 2.25-2.25 2.25-2.25-1.008-2.25-2.25 1.008-2.25 2.25-2.25zm0 1.35c.497 0 .9.403.9.9s-.403.9-.9.9-.9-.403-.9-.9.403-.9.9-.9z" />
          </svg>
        );

      case "segmento-vendedor":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            width={width}
            fill={fill ? fill : color1}
            height={height}
            className={className}
            style={style}
          >
            <path d="M12.005 5.001c-.687 0-1.245.559-1.245 1.246 0 .687.558 1.245 1.245 1.245s1.245-.558 1.245-1.245-.558-1.246-1.245-1.246m0 3.492c-1.238 0-2.245-1.008-2.245-2.246 0-1.239 1.007-2.247 2.245-2.247 1.237 0 2.245 1.008 2.245 2.247 0 1.238-1.008 2.246-2.245 2.246m6.74-3.492c-.686 0-1.245.559-1.245 1.246 0 .687.559 1.245 1.245 1.245.687 0 1.245-.558 1.245-1.245s-.558-1.246-1.245-1.246m0 3.492c-1.238 0-2.245-1.008-2.245-2.246 0-1.239 1.007-2.247 2.245-2.247 1.239 0 2.245 1.008 2.245 2.247 0 1.238-1.006 2.246-2.245 2.246m-13.49-3.492c-.687 0-1.245.559-1.245 1.246 0 .687.558 1.245 1.245 1.245s1.245-.558 1.245-1.245-.558-1.246-1.245-1.246m0 3.492c-1.238 0-2.245-1.008-2.245-2.246 0-1.239 1.007-2.247 2.245-2.247 1.238 0 2.245 1.008 2.245 2.247 0 1.238-1.007 2.246-2.245 2.246m13.665 6.161c.541 0 .979.403 1.018.935.032.438.29 3.26.29 3.26.023.262.425.251.436.002l.315-6.936c.021-.489.67-.662.925-.237l1.097 1.802-1.057-3.329c-.038-.123-.182-.211-.342-.211h-19.203c-.161 0-.305.088-.343.211l-1.06 3.4 1.1-1.873c.262-.43.905-.246.926.237l.314 6.936c.013.244.412.247.437-.002 0 0 .257-2.822.29-3.261.039-.531.476-.934 1.017-.934.465 0 .97.351 1.013.935.033.438.29 3.26.29 3.26.027.264.437.268.437.001.082-1.812.417-7.612.417-7.612.016-.261.231-.467.493-.47 1.007-.011.621-.011 1.624 0 .262.003.477.209.492.47 0 0 .282 5.803.418 7.613.022.292.427.266.436-.001 0 0 .258-2.823.291-3.262.042-.583.548-.934 1.012-.934.47 0 .977.351 1.018.937.033.451.291 3.258.291 3.258.033.255.421.263.436.001.082-1.812.417-7.612.417-7.612.015-.261.232-.467.494-.47.997-.011.615-.011 1.61 0 .262.003.479.209.494.47 0 0 .335 5.8.417 7.613.014.241.414.232.436 0 0 0 .258-2.809.291-3.263.041-.583.547-.934 1.013-.934m1.526 5.346c-.64 0-1.163-.459-1.214-1.065 0 0-.259-2.83-.292-3.273-.069.458-.328 3.273-.328 3.273-.049.606-.571 1.065-1.212 1.065-.655 0-1.189-.485-1.218-1.103-.069-1.498-.31-5.722-.391-7.133h-.654c-.081 1.411-.322 5.635-.391 7.132-.029.619-.563 1.104-1.217 1.104-.641 0-1.163-.459-1.213-1.067 0 0-.259-2.813-.293-3.271-.068.443-.327 3.273-.327 3.273-.05.606-.572 1.065-1.213 1.065-.654 0-1.189-.485-1.218-1.103-.069-1.498-.309-5.721-.39-7.133h-.666c-.081 1.412-.322 5.635-.39 7.132-.029.619-.564 1.104-1.217 1.104-.64 0-1.163-.459-1.215-1.065 0 0-.258-2.83-.291-3.273-.069.443-.327 3.273-.327 3.273-.052.606-.574 1.065-1.214 1.065-.654 0-1.189-.485-1.218-1.103l-.24-5.298-.244.401c-.234.389-.759.569-1.202.413-.389-.136-.651-.494-.651-.891l.041-.268 1.061-3.401c.17-.546.692-.914 1.297-.914h19.203c.595 0 1.129.375 1.298.914l1.059 3.399.041.27c0 .398-.263.755-.652.891-.415.149-.966-.023-1.201-.414l-.245-.401-.24 5.298c-.027.619-.561 1.104-1.216 1.104" />
          </svg>
        );

      case "vendedor":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            width={width}
            fill={fill ? fill : color1}
            height={height}
            className={className}
            style={style}
          >
            <path d="M9.602 3.7c-1.154 1.937-.635 5.227 1.424 9.025.93 1.712.697 3.02.338 3.815-.982 2.178-3.675 2.799-6.525 3.456-1.964.454-1.839.87-1.839 4.004h-1.995l-.005-1.241c0-2.52.199-3.975 3.178-4.663 3.365-.777 6.688-1.473 5.09-4.418-4.733-8.729-1.35-13.678 3.732-13.678 3.321 0 5.97 2.117 5.97 6.167 0 3.555-1.949 6.833-2.383 7.833h-2.115c.392-1.536 2.499-4.366 2.499-7.842 0-5.153-5.867-4.985-7.369-2.458zm13.398 15.3h-3v-3h-2v3h-3v2h3v3h2v-3h3v-2z" />
          </svg>
        );

      case "edit":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 -960 960 960"
            width={width}
            fill={fill ? fill : color1}
            height={height}
            className={className}
            style={style}
          >
            <path d="M212.308-200h42.923L651-595.769l-42.923-42.923-395.769 395.769V-200Zm524.308-424.538-100.001-99.539 48.308-48.308q12.231-12.231 29.192-12.231 16.962 0 29.193 12.231L784.693-731q12.23 12.231 12.461 28.961.231 16.731-12 28.962l-48.538 48.539Zm-28.77 29L272.308-160H172.307v-100l435.539-435.539 100 100.001Zm-78.692-22.077-21.077-21.077L651-595.769l-21.846-21.846Z" />
          </svg>
        );

      case "person":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 -960 960 960"
            width={width}
            fill={fill ? fill : color1}
            height={height}
            className={className}
            style={style}
          >
            <path d="M480-504.615q-49.5 0-84.75-35.25T360-624.615q0-49.501 35.25-84.751 35.25-35.25 84.75-35.25t84.75 35.25Q600-674.116 600-624.615q0 49.5-35.25 84.75T480-504.615ZM200-215.384v-65.847q0-24.769 14.423-46.346 14.423-21.577 38.808-33.5 56.615-27.154 113.307-40.731Q423.231-415.385 480-415.385q56.769 0 113.462 13.577 56.692 13.577 113.307 40.731 24.385 11.923 38.808 33.5Q760-306 760-281.231v65.847H200Zm40-40.001h480v-25.846q0-13.307-8.577-25-8.577-11.692-23.731-19.769-49.384-23.923-101.836-36.654Q533.405-375.385 480-375.385q-53.405 0-105.856 12.731Q321.692-349.923 272.308-326q-15.154 8.077-23.731 19.769-8.577 11.693-8.577 25v25.846Zm240-289.23q33 0 56.5-23.5t23.5-56.5q0-33-23.5-56.5t-56.5-23.5q-33 0-56.5 23.5t-23.5 56.5q0 33 23.5 56.5t56.5 23.5Zm0-80Zm0 369.23Z" />
          </svg>
        );

      case "group-person":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 -960 960 960"
            width={width}
            fill={fill ? fill : color1}
            height={height}
            className={className}
            style={style}
          >
            <path d="M103.846-215.384v-65.847q0-27.846 14.423-47.884 14.423-20.039 38.765-32.029 52.043-24.779 103.35-39.51 51.308-14.731 123.462-14.731t123.462 14.731q51.307 14.731 103.35 39.51 24.342 11.99 38.765 32.029 14.423 20.038 14.423 47.884v65.847h-560Zm640 0v-67.693q0-34.769-14.074-65.64-14.075-30.871-39.926-52.976 29.462 6 56.769 16.654 27.308 10.654 54.001 23.962 26 13.077 40.769 33.469 14.769 20.393 14.769 44.531v67.693H743.846Zm-360-289.231q-49.5 0-84.75-35.25t-35.25-84.75q0-49.501 35.25-84.751 35.25-35.25 84.75-35.25t84.75 35.25q35.25 35.25 35.25 84.751 0 49.5-35.25 84.75t-84.75 35.25Zm290.77-120q0 49.5-35.25 84.75t-84.75 35.25q-2.539 0-6.462-.577-3.923-.577-6.462-1.269 20.325-24.895 31.239-55.235 10.915-30.34 10.915-63.015 0-32.674-11.423-62.443t-30.731-55.616q3.231-1.153 6.462-1.5 3.231-.346 6.462-.346 49.5 0 84.75 35.25t35.25 84.751Zm-530.77 369.23h480v-25.846q0-14.077-7.038-24.615-7.039-10.539-25.27-20.154-44.769-23.923-94.384-36.654-49.616-12.731-113.308-12.731-63.692 0-113.308 12.731-49.615 12.731-94.384 36.654-18.231 9.615-25.27 20.154-7.038 10.538-7.038 24.615v25.846Zm240-289.23q33 0 56.5-23.5t23.5-56.5q0-33-23.5-56.5t-56.5-23.5q-33 0-56.5 23.5t-23.5 56.5q0 33 23.5 56.5t56.5 23.5Zm0 289.23Zm0-369.23Z" />
          </svg>
        );

      case "clock-off":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            className={className}
            fill={fill ? fill : color1}
            style={style}
            viewBox="0 -960 960 960"
          >
            <path d="m768.769-304-30-30q11-26.231 16.116-52.731Q760-413.231 760-440q0-116-82-198t-198-82q-24 0-52.538 5-28.539 5-53.693 16l-30-30q31.077-15.385 66.269-23.193Q445.231-760 480-760q56.923 0 110.962 20.384Q645-719.231 691.385-680.462l43.692-43.692 28.308 28.308-43.692 43.692q38.769 46.385 59.538 100.808Q800-496.923 800-440q0 34.308-7.807 69.269-7.808 34.962-23.424 66.731ZM500-572.769v-51.846h-40v11.846l40 40ZM798.154-105.23 697.538-205.846q-42.615 40.385-99.653 63.116Q540.846-120 480-120q-66.308 0-124.5-25.038-58.192-25.039-101.808-68.654-43.615-43.616-68.654-101.808Q160-373.692 160-440q0-61.538 21.961-117.423 21.962-55.885 63.885-100.115L105.23-798.154l28.308-28.308 692.924 692.924-28.308 28.308ZM480-160q51.231 0 100.077-19.538 48.846-19.539 88.461-55.077L274.154-629q-35.539 38.077-54.846 86.539Q200-494 200-440q0 116 82 198t198 82ZM375.385-860v-40h209.23v40h-209.23Zm96.076 428.077ZM556.769-517Z" />
          </svg>
        );

      case "clock":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            className={className}
            fill={fill ? fill : color1}
            style={style}
            viewBox="0 0 24 24"
          >
            <path d="M12 2c5.514 0 10 4.486 10 10s-4.486 10-10 10-10-4.486-10-10 4.486-10 10-10zm0-2c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm1 12v-6h-2v8h7v-2h-5z" />
          </svg>
        );

      case "clock-thin":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            className={className}
            fill={fill ? fill : color1}
            style={style}
            viewBox="0 -960 960 960"
          >
            <path d="M375.385-860v-40h209.23v40h-209.23ZM460-415.385h40v-209.23h-40v209.23ZM480-120q-66.308 0-124.5-25.038-58.192-25.039-101.808-68.654-43.615-43.616-68.654-101.808Q160-373.692 160-440q0-66.308 25.038-124.5 25.039-58.192 68.654-101.808 43.616-43.615 101.808-68.654Q413.692-760 480-760q58.154 0 112.462 20.769 54.307 20.769 99.692 58.769l43.692-43.692 28.308 28.308-43.692 43.692q38 45.385 58.769 99.692Q800-498.154 800-440q0 66.308-25.038 124.5-25.039 58.192-68.654 101.808-43.616 43.615-101.808 68.654Q546.308-120 480-120Zm0-40q116 0 198-82t82-198q0-116-82-198t-198-82q-116 0-198 82t-82 198q0 116 82 198t198 82Zm0-280Z" />
          </svg>
        );

      case "automatizacion":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            className={className}
            fill={fill ? fill : color1}
            style={style}
            viewBox="0 0 24 24"
          >
            <path d="M13.001 24h-2v-3.558c.328.038.662.058 1 .058.339 0 .672-.02 1-.058v3.558zm4.072-5.181l1.774 3.087-1.734.997-1.773-3.085c.619-.265 1.2-.601 1.733-.999zm-10.161-.012c.533.399 1.113.736 1.731 1.003l-1.78 3.08-1.732-1 1.781-3.083zm5.388.193h-.596c-.156 0-.307-.053-.41-.145l-.792-.522h3l-.792.522c-.102.092-.253.145-.41.145zm7.507-3.632l3.078 1.784-1.003 1.73-3.08-1.785c.399-.532.738-1.112 1.005-1.729zm-15.62-.019c.266.618.603 1.199 1.001 1.731l-3.085 1.778-.998-1.733 3.082-1.776zm9.343 2.318h-3.038c-.184 0-.334-.149-.334-.334 0-.184.15-.333.334-.333h3.038c.184 0 .334.149.334.333 0 .185-.149.334-.334.334zm.33-1.334h-3.715c0-2.632-2.143-3.772-2.143-6.152 0-2.482 1.999-3.848 3.998-3.848 2.001 0 4.002 1.368 4.002 3.848 0 2.38-2.142 3.483-2.142 6.152zm6.584-5.323l3.558.005-.002 2-3.558-.005c.039-.331.059-.668.059-1.01 0-.335-.019-.665-.057-.99zm-16.883-.02c-.04.331-.06.668-.06 1.01 0 .335.02.665.057.99l-3.558-.005.002-2 3.559.005zm15.254-4.07l3.084-1.778.999 1.733-3.083 1.776c-.266-.618-.603-1.199-1-1.731zm-13.615-.017c-.399.532-.737 1.112-1.004 1.729l-3.079-1.784 1.003-1.73 3.08 1.785zm10.159-2.713l1.781-3.08 1.731 1-1.781 3.083c-.532-.399-1.112-.736-1.731-1.003zm-6.697-.008c-.619.265-1.2.601-1.733.999l-1.774-3.087 1.734-.997 1.773 3.085zm4.339-.624c-.328-.038-.661-.058-1-.058-.338 0-.672.02-1 .058v-3.558h2v3.558z" />
          </svg>
        );

      case "log":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            className={className}
            fill={fill ? fill : color1}
            style={style}
            viewBox="0 0 24 24"
          >
            <path d="M11.362 2c4.156 0 2.638 6 2.638 6s6-1.65 6 2.457v11.543h-16v-20h7.362zm.827-2h-10.189v24h20v-14.386c0-2.391-6.648-9.614-9.811-9.614zm4.811 13h-10v-1h10v1zm0 2h-10v1h10v-1zm0 3h-10v1h10v-1z" />
          </svg>
        );

      case "setting":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            fill={fill ? fill : color1}
            style={style}
            viewBox="0 0 24 24"
          >
            <path
              d="M24 14.187v-4.374c-2.148-.766-2.726-.802-3.027-1.529-.303-.729.083-1.169 1.059-3.223l-3.093-3.093c-2.026.963-2.488
               1.364-3.224 1.059-.727-.302-.768-.889-1.527-3.027h-4.375c-.764 2.144-.8 2.725-1.529 3.027-.752.313-1.203-.1-3.223-1.059l-3.093
                3.093c.977 2.055 1.362 2.493 1.059 3.224-.302.727-.881.764-3.027 1.528v4.375c2.139.76 2.725.8 3.027 1.528.304.734-.081 1.167-1.059
                 3.223l3.093 3.093c1.999-.95 2.47-1.373 3.223-1.059.728.302.764.88 1.529 3.027h4.374c.758-2.131.799-2.723 1.537-3.031.745-.308
                  1.186.099 3.215 1.062l3.093-3.093c-.975-2.05-1.362-2.492-1.059-3.223.3-.726.88-.763 3.027-1.528zm-4.875.764c-.577 1.394-.068
                   2.458.488 3.578l-1.084 1.084c-1.093-.543-2.161-1.076-3.573-.49-1.396.581-1.79
                    1.693-2.188 2.877h-1.534c-.398-1.185-.791-2.297-2.183-2.875-1.419-.588-2.507-.045-3.579.488l-1.083-1.084c.557-1.118
                     1.066-2.18.487-3.58-.579-1.391-1.691-1.784-2.876-2.182v-1.533c1.185-.398 2.297-.791 2.875-2.184.578-1.394.068-2.459-.488-3.579l1.084-1.084c1.082.538
                      2.162 1.077 3.58.488 1.392-.577 1.785-1.69 2.183-2.875h1.534c.398 1.185.792 2.297 2.184 2.875 1.419.588 2.506.045 3.579-.488l1.084 1.084c-.556
                       1.121-1.065 2.187-.488 3.58.577 1.391 1.689 1.784 2.875 2.183v1.534c-1.188.398-2.302.791-2.877 2.183zm-7.125-5.951c1.654 0 3 1.346 3 3s-1.346
                        3-3 3-3-1.346-3-3 1.346-3 3-3zm0-2c-2.762 0-5 2.238-5 5s2.238 5 5 5 5-2.238 5-5-2.238-5-5-5z"
            />
          </svg>
        );

      case "help":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            className={className}
            fill={fill ? fill : color1}
            style={style}
            viewBox="0 0 24 24"
          >
            <path d="M12 3c5.514 0 10 3.592 10 8.007 0 4.917-5.145 7.961-9.91 7.961-1.937 0-3.383-.397-4.394-.644-1 .613-1.595 1.037-4.272 1.82.535-1.373.723-2.748.602-4.265-.838-1-2.025-2.4-2.025-4.872-.001-4.415 4.485-8.007 9.999-8.007zm0-2c-6.338 0-12 4.226-12 10.007 0 2.05.738 4.063 2.047 5.625.055 1.83-1.023 4.456-1.993 6.368 2.602-.47 6.301-1.508 7.978-2.536 1.418.345 2.775.503 4.059.503 7.084 0 11.91-4.837 11.91-9.961-.001-5.811-5.702-10.006-12.001-10.006zm1.024 13.975c0 .566-.458 1.025-1.024 1.025-.565 0-1.024-.459-1.024-1.025 0-.565.459-1.024 1.024-1.024.566 0 1.024.459 1.024 1.024zm1.141-8.192c-.498-.505-1.241-.783-2.09-.783-1.786 0-2.941 1.271-2.941 3.237h1.647c0-1.217.68-1.649 1.261-1.649.519 0 1.07.345 1.117 1.004.052.694-.319 1.046-.788 1.493-1.157 1.1-1.179 1.633-1.173 2.842h1.643c-.01-.544.025-.986.766-1.785.555-.598 1.245-1.342 1.259-2.477.008-.758-.233-1.409-.701-1.882z" />
          </svg>
        );

      case "save":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            className={className}
            fill={fill ? fill : color1}
            style={style}
            viewBox="0 0 24 24"
          >
            <path d="M13 3h2.996v5h-2.996v-5zm11 1v20h-24v-24h20l4 4zm-17 5h10v-7h-10v7zm15-4.171l-2.828-2.829h-.172v9h-14v-9h-3v20h20v-17.171zm-3 10.171h-14v1h14v-1zm0 2h-14v1h14v-1zm0 2h-14v1h14v-1z" />
          </svg>
        );

      case "global":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            className={className}
            fill={fill ? fill : color1}
            style={style}
            viewBox="0 0 24 24"
          >
            <path d="M13.144 8.171c-.035-.066.342-.102.409-.102.074.009-.196.452-.409.102zm-2.152-3.072l.108-.031c.064.055-.072.095-.051.136.086.155.021.248.008.332-.014.085-.104.048-.149.093-.053.066.258.075.262.085.011.033-.375.089-.304.171.096.136.824-.195.708-.176.225-.113.029-.125-.097-.19-.043-.215-.079-.547-.213-.68l.088-.102c-.206-.299-.36.362-.36.362zm13.008 6.901c0 6.627-5.373 12-12 12-6.628 0-12-5.373-12-12s5.372-12 12-12c6.627 0 12 5.373 12 12zm-8.31-5.371c-.006-.146-.19-.284-.382-.031-.135.174-.111.439-.184.557-.104.175.567.339.567.174.025-.277.732-.063.87-.025.248.069.643-.226.211-.381-.355-.13-.542-.269-.574-.523 0 0 .188-.176.106-.166-.218.027-.614.786-.614.395zm6.296 5.371c0-1.035-.177-2.08-.357-2.632-.058-.174-.189-.312-.359-.378-.256-.1-1.337.597-1.5.254-.107-.229-.324.146-.572.008-.12-.066-.454-.515-.605-.46-.309.111.474.964.688 1.076.201-.152.852-.465.992-.038.268.804-.737 1.685-1.251 2.149-.768.694-.624-.449-1.147-.852-.275-.211-.272-.66-.55-.815-.124-.07-.693-.725-.688-.813l-.017.166c-.094.071-.294-.268-.315-.321 0 .295.48.765.639 1.001.271.405.416.995.748 1.326.178.178.858.914 1.035.898.193-.017.803-.458.911-.433.644.152-1.516 3.205-1.721 3.583-.169.317.138 1.101.113 1.476-.029.433-.37.573-.693.809-.346.253-.265.745-.556.925-.517.318-.889 1.353-1.623 1.348-.216-.001-1.14.36-1.261.007-.094-.256-.22-.45-.353-.703-.13-.248-.015-.505-.173-.724-.109-.152-.475-.497-.508-.677-.002-.155.117-.626.28-.708.229-.117.044-.458.016-.656-.048-.354-.267-.646-.53-.851-.389-.299-.188-.537-.097-.964 0-.204-.124-.472-.398-.392-.564.164-.393-.44-.804-.413-.296.021-.538.209-.813.292-.346.104-.7-.082-1.042-.125-1.407-.178-1.866-1.786-1.499-2.946.037-.19-.114-.542-.048-.689.158-.352.48-.747.762-1.014.158-.15.361-.112.547-.229.287-.181.291-.553.572-.781.4-.325.946-.318 1.468-.388.278-.037 1.336-.266 1.503-.06 0 .038.191.604-.019.572.433.023 1.05.749 1.461.579.211-.088.134-.736.567-.423.262.188 1.436.272 1.68.069.15-.124.234-.93.052-1.021.116.115-.611.124-.679.098-.12-.044-.232.114-.425.025.116.055-.646-.354-.218-.667-.179.131-.346-.037-.539.107-.133.108.062.18-.128.274-.302.153-.53-.525-.644-.602-.116-.076-1.014-.706-.77-.295l.789.785c-.039.025-.207-.286-.207-.059.053-.135.02.579-.104.347-.055-.089.09-.139.006-.268 0-.085-.228-.168-.272-.226-.125-.155-.457-.497-.637-.579-.05-.023-.764.087-.824.11-.07.098-.13.201-.179.311-.148.055-.287.126-.419.214l-.157.353c-.068.061-.765.291-.769.3.029-.075-.487-.171-.453-.321.038-.165.213-.68.168-.868-.048-.197 1.074.284 1.146-.235.029-.225.046-.487-.313-.525.068.008.695-.246.799-.36.146-.168.481-.442.724-.442.284 0 .223-.413.354-.615.131.053-.07.376.087.507-.01-.103.445.057.489.033.104-.054.684-.022.594-.294-.1-.277.051-.195.181-.253-.022.009.34-.619.402-.413-.043-.212-.421.074-.553.063-.305-.024-.176-.52-.061-.665.089-.115-.243-.256-.247-.036-.006.329-.312.627-.241 1.064.108.659-.735-.159-.809-.114-.28.17-.509-.214-.364-.444.148-.235.505-.224.652-.476.104-.178.225-.385.385-.52.535-.449.683-.09 1.216-.041.521.048.176.124.104.324-.069.19.286.258.409.099.07-.092.229-.323.298-.494.089-.222.901-.197.334-.536-.374-.223-2.004-.672-3.096-.672-.236 0-.401.263-.581.412-.356.295-1.268.874-1.775.698-.519-.179-1.63.66-1.808.666-.065.004.004-.634.358-.681-.153.023 1.247-.707 1.209-.859-.046-.18-2.799.822-2.676 1.023.059.092.299.092-.016.294-.18.109-.372.801-.541.801-.505.221-.537-.435-1.099.409l-.894.36c-1.328 1.411-2.247 3.198-2.58 5.183-.013.079.334.226.379.28.112.134.112.712.167.901.138.478.479.744.74 1.179.154.259.41.914.329 1.186.108-.178 1.07.815 1.246 1.022.414.487.733 1.077.061 1.559-.217.156.33 1.129.048 1.368l-.361.093c-.356.219-.195.756.021.982 1.818 1.901 4.38 3.087 7.22 3.087 5.517 0 9.989-4.472 9.989-9.989zm-11.507-6.357c.125-.055.293-.053.311-.22.015-.148.044-.046.08-.1.035-.053-.067-.138-.11-.146-.064-.014-.108.069-.149.104l-.072.019-.068.087.008.048-.087.106c-.085.084.002.139.087.102z" />
          </svg>
        );

      case "send":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            className={className}
            fill={fill ? fill : color1}
            style={style}
            viewBox="0 0 24 24"
          >
            <path d="M0 12l11 3.1 7-8.1-8.156 5.672-4.312-1.202 15.362-7.68-3.974 14.57-3.75-3.339-2.17 2.925v-.769l-2-.56v7.383l4.473-6.031 4.527 4.031 6-22z" />
          </svg>
        );

      case "email":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            className={className}
            fill={fill ? fill : color1}
            style={style}
            viewBox="0 0 24 24"
          >
            <path d="M0 3v18h24v-18h-24zm21.518 2l-9.518 7.713-9.518-7.713h19.036zm-19.518 14v-11.817l10 8.104 10-8.104v11.817h-20z" />
          </svg>
        );
      case "refresh":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            className={className}
            fill={fill ? fill : color1}
            style={style}
            viewBox="0 0 24 24"
          >
            <path d="M13.5 2c-5.288 0-9.649 3.914-10.377 9h-3.123l4 5.917 4-5.917h-2.847c.711-3.972 4.174-7 8.347-7 4.687 0 8.5 3.813 8.5 8.5s-3.813 8.5-8.5 8.5c-3.015 0-5.662-1.583-7.171-3.957l-1.2 1.775c1.916 2.536 4.948 4.182 8.371 4.182 5.797 0 10.5-4.702 10.5-10.5s-4.703-10.5-10.5-10.5z" />
          </svg>
        );
      case "cycle":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            className={className}
            fill={fill ? fill : color1}
            style={style}
            viewBox="0 0 24 24"
            strokeMiterlimit={2}
            strokeLinejoin="round"
            fillRule="evenodd"
            clipRule="evenodd"
          >
            <path
              d="m21.897 13.404.008-.057v.002c.024-.178.044-.357.058-.537.024-.302-.189-.811-.749-.811-.391 0-.715.3-.747.69-.018.221-.044.44-.078.656-.645 4.051-4.158 7.153-8.391 7.153-3.037 0-5.704-1.597-7.206-3.995l1.991-.005c.414 0 .75-.336.75-.75s-.336-.75-.75-.75h-4.033c-.414 0-.75.336-.75.75v4.049c0 .414.336.75.75.75s.75-.335.75-.75l.003-2.525c1.765 2.836 4.911 4.726 8.495 4.726 5.042 0 9.217-3.741 9.899-8.596zm-19.774-2.974-.009.056v-.002c-.035.233-.063.469-.082.708-.024.302.189.811.749.811.391 0 .715-.3.747-.69.022-.28.058-.556.107-.827.716-3.968 4.189-6.982 8.362-6.982 3.037 0 5.704 1.597 7.206 3.995l-1.991.005c-.414 0-.75.336-.75.75s.336.75.75.75h4.033c.414 0 .75-.336.75-.75v-4.049c0-.414-.336-.75-.75-.75s-.75.335-.75.75l-.003 2.525c-1.765-2.836-4.911-4.726-8.495-4.726-4.984 0-9.12 3.654-9.874 8.426z"
              fillRule="nonzero"
            />
          </svg>
        );

      case "create":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            className={className}
            fill={fill ? fill : color1}
            style={style}
            viewBox="0 0 24 24"
          >
            <path d="M24 10h-10v-10h-4v10h-10v4h10v10h4v-10h10z" />
          </svg>
        );

      case "circle-plus":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            className={className}
            fill={fill ? fill : color1}
            style={style}
            viewBox="0 0 24 24"
          >
            <path d="M12 2c5.514 0 10 4.486 10 10s-4.486 10-10 10-10-4.486-10-10 4.486-10 10-10zm0-2c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm6 13h-5v5h-2v-5h-5v-2h5v-5h2v5h5v2z" />
          </svg>
        );

      case "send-message":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            className={className}
            fill={fill ? fill : color1}
            style={style}
            viewBox="0 0 24 24"
          >
            <path d="M12 3c5.514 0 10 3.592 10 8.007 0 4.917-5.145 7.961-9.91 7.961-1.937 0-3.383-.397-4.394-.644-1 .613-1.595 1.037-4.272 1.82.535-1.373.723-2.748.602-4.265-.838-1-2.025-2.4-2.025-4.872-.001-4.415 4.485-8.007 9.999-8.007zm0-2c-6.338 0-12 4.226-12 10.007 0 2.05.738 4.063 2.047 5.625.055 1.83-1.023 4.456-1.993 6.368 2.602-.47 6.301-1.508 7.978-2.536 1.418.345 2.775.503 4.059.503 7.084 0 11.91-4.837 11.91-9.961-.001-5.811-5.702-10.006-12.001-10.006zm0 14h-5v-1h5v1zm5-3h-10v-1h10v1zm0-3h-10v-1h10v1z" />
          </svg>
        );

      case "money":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            className={className}
            fill={fill ? fill : color1}
            style={style}
            viewBox="0 0 24 24"
          >
            <path d="M20.667 14c1.781 0 3.333-.671 3.333-1.5s-1.552-1.5-3.333-1.5c-1.781 0-3.333.671-3.333 1.5s1.551 1.5 3.333 1.5zm.062-1.34c-.199-.06-.81-.111-.81-.45 0-.189.223-.358.639-.396v-.148h.214v.141c.156.004.33.021.523.06l-.078.229c-.147-.034-.311-.066-.472-.066l-.048.001c-.321.013-.347.191-.125.267.364.112.844.195.844.493 0 .238-.289.366-.645.397v.146h-.214v-.139c-.22-.002-.451-.038-.642-.102l.098-.229c.163.042.367.084.552.084l.139-.01c.247-.034.296-.199.025-.278zm-.062 5.34c1.261 0 2.57-.323 3.333-.934v.434c0 .829-1.552 1.5-3.333 1.5-1.781 0-3.333-.671-3.333-1.5v-.434c.763.611 2.071.934 3.333.934zm0-3.333c1.261 0 2.57-.323 3.333-.934v.434c0 .829-1.552 1.5-3.333 1.5-1.781 0-3.333-.671-3.333-1.5v-.434c.763.611 2.071.934 3.333.934zm0 1.666c1.261 0 2.57-.323 3.333-.935v.435c0 .828-1.552 1.5-3.333 1.5-1.781 0-3.333-.672-3.333-1.5v-.435c.763.612 2.071.935 3.333.935zm-12.167-3.833c0 1.38 1.12 2.5 2.5 2.5s2.5-1.12 2.5-2.5-1.12-2.5-2.5-2.5-2.5 1.12-2.5 2.5zm3.236-1.14l-.09.411c-.192-.067-.405-.128-.611-.116-.372.022-.405.344-.145.479.428.201.985.35.985.886.001.429-.334.659-.749.716v.264h-.251v-.25c-.259-.004-.526-.066-.749-.181l.113-.411c.239.092.558.191.807.135.287-.065.346-.36.028-.503-.233-.108-.944-.201-.944-.811 0-.341.261-.646.746-.713v-.266h.251v.254c.179.005.382.037.609.106zm6.264-5.36h-17v10h-1v-11h18v1zm2 1v2.834c-.715.059-1.401.214-2 .458v-1.292h-14v7h12v2h-14v-11h18z" />
          </svg>
        );

      case "minus-crm":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            className={className}
            fill={fill ? fill : color1}
            style={style}
            viewBox="0 0 24 24"
          >
            <path d="M0 10h24v4h-24z" />
          </svg>
        );

      case "plus-crm":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            className={className}
            fill={fill ? fill : color1}
            style={style}
            viewBox="0 0 24 24"
            id={id}
          >
            <path d="M24 10h-10v-10h-4v10h-10v4h10v10h4v-10h10z" />
          </svg>
        );

      case "check":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            className={className}
            fill={fill ? fill : color1}
            style={style}
            viewBox="0 0 24 24"
          >
            <path d="M9 22l-10-10.598 2.798-2.859 7.149 7.473 13.144-14.016 2.909 2.806z" />
          </svg>
        );

      case "view":
        return (
          <svg
            clipRule="evenodd"
            fillRule="evenodd"
            strokeLinejoin="round"
            strokeMiterlimit="2"
            className={className}
            width={width}
            height={height}
            fill={fill ? fill : color1}
            xmlns="http://www.w3.org/2000/svg"
            style={style}
            viewBox="0 0 24 24"
          >
            <path d="m11.998 5c-4.078 0-7.742 3.093-9.853 6.483-.096.159-.145.338-.145.517s.048.358.144.517c2.112 3.39 5.776 6.483 9.854 6.483 4.143 0 7.796-3.09 9.864-6.493.092-.156.138-.332.138-.507s-.046-.351-.138-.507c-2.068-3.403-5.721-6.493-9.864-6.493zm8.413 7c-1.837 2.878-4.897 5.5-8.413 5.5-3.465 0-6.532-2.632-8.404-5.5 1.871-2.868 4.939-5.5 8.404-5.5 3.518 0 6.579 2.624 8.413 5.5zm-8.411-4c2.208 0 4 1.792 4 4s-1.792 4-4 4-4-1.792-4-4 1.792-4 4-4zm0 1.5c-1.38 0-2.5 1.12-2.5 2.5s1.12 2.5 2.5 2.5 2.5-1.12 2.5-2.5-1.12-2.5-2.5-2.5z" />
          </svg>
        );
      case "back":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            className={className}
            fill={fill ? fill : color1}
            style={style}
            viewBox="0 0 24 24"
          >
            <path
              d="m9.474 5.209s-4.501 4.505-6.254 6.259c-.147.146-.22.338-.22.53s.073.384.22.53c1.752 1.754 6.252 6.257 6.252 6.257.145.145.336.217.527.217.191-.001.383-.074.53-.221.293-.293.294-.766.004-1.057l-4.976-4.976h14.692c.414 0 .75-.336.75-.75s-.336-.75-.75-.75h-14.692l4.978-4.979c.289-.289.287-.761-.006-1.054-.147-.147-.339-.221-.53-.221-.191-.001-.38.071-.525.215z"
              fillRule="nonzero"
            />
          </svg>
        );
      case "call":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            className={className}
            fill={fill ? fill : color1}
            style={style}
            viewBox="0 0 24 24"
          >
            <path d="M6.176 1.322l2.844-1.322 4.041 7.89-2.724 1.341c-.538 1.259 2.159 6.289 3.297 6.372.09-.058 2.671-1.328 2.671-1.328l4.11 7.932s-2.764 1.354-2.854 1.396c-7.862 3.591-19.103-18.258-11.385-22.281zm1.929 1.274l-1.023.504c-5.294 2.762 4.177 21.185 9.648 18.686l.971-.474-2.271-4.383-1.026.5c-3.163 1.547-8.262-8.219-5.055-9.938l1.007-.497-2.251-4.398z" />
          </svg>
        );

      case "event":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            className={className}
            fill={fill ? fill : color1}
            style={style}
            viewBox="0 0 24 24"
          >
            <path d="M17 3v-2c0-.552.447-1 1-1s1 .448 1 1v2c0 .552-.447 1-1 1s-1-.448-1-1zm-12 1c.553 0 1-.448 1-1v-2c0-.552-.447-1-1-1-.553 0-1 .448-1 1v2c0 .552.447 1 1 1zm13 13v-3h-1v4h3v-1h-2zm-5 .5c0 2.481 2.019 4.5 4.5 4.5s4.5-2.019 4.5-4.5-2.019-4.5-4.5-4.5-4.5 2.019-4.5 4.5zm11 0c0 3.59-2.91 6.5-6.5 6.5s-6.5-2.91-6.5-6.5 2.91-6.5 6.5-6.5 6.5 2.91 6.5 6.5zm-14.237 3.5h-7.763v-13h19v1.763c.727.33 1.399.757 2 1.268v-9.031h-3v1c0 1.316-1.278 2.339-2.658 1.894-.831-.268-1.342-1.111-1.342-1.984v-.91h-9v1c0 1.316-1.278 2.339-2.658 1.894-.831-.268-1.342-1.111-1.342-1.984v-.91h-3v21h11.031c-.511-.601-.938-1.273-1.268-2z" />
          </svg>
        );

      case "item":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            className={className}
            fill={fill ? fill : color1}
            style={style}
            viewBox="0 0 24 24"
            fillRule="evenodd"
            clipRule="evenodd"
          >
            <path d="M15.744 16.683l.349-.199v1.717l-.349.195v-1.713zm3.414-.227l.342-.196v-1.717l-.343.195v1.718zm-1.429.813l.343-.195v-1.717l-.343.195v1.717zm.578-.329l.349-.199v-1.717l-.349.199v1.717zm-1.152.656l.343-.196v-1.717l-.343.196v1.717zm-.821.467l.343-.195v-1.717l-.343.195v1.717zm6.666-11.122v11.507l-9.75 5.552-12.25-6.978v-11.507l9.767-5.515 12.233 6.941zm-12.236-4.643l-2.106 1.19 8.891 5.234-.002.003 2.33-1.256-9.113-5.171zm1.236 10.59l-9-5.218v8.19l9 5.126v-8.098zm3.493-3.056l-8.847-5.208-2.488 1.405 8.86 5.138 2.475-1.335zm5.507-.696l-7 3.773v8.362l7-3.985v-8.15z" />
          </svg>
        );

      case "item-type":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            className={className}
            fill={fill ? fill : color1}
            style={style}
            viewBox="0 0 24 24"
          >
            <path d="M16.334 16.347l.343-.195v1.717l-.343.195v-1.717zm-.59 2.049l.349-.195v-1.717l-.349.199v1.713zm1.985-1.127l.343-.195v-1.717l-.343.195v1.717zm1.771-2.726l-.342.195v1.717l.342-.195v-1.717zm-2.346 3.053l.344-.196v-1.717l-.344.196v1.717zm5.846-10.655v11.507l-9.75 5.552-12.25-6.978v-11.507l9.767-5.515 12.233 6.941zm-13.846-3.733l9.022 5.178 1.7-.917-9.113-5.17-1.609.909zm-3.374 12.601c-.116-.648.087-1.024.56-1.666l.294.435-.416-1.595-1.1-.654.287.433c-.531.743-.665.972.375 3.047zm1.546-.313l-1.062-.638c-.412.441-.3 1.375-.042 1.519l1.042.626.062-1.507zm0-3.05c-.23-.924-.857-1.546-.986-1.318l-.518.834.978 1.334.526-.85zm.457.693l-.325.038 1.151.832.529-1.017-.323.028c-.467-1.404-.543-1.707-2.044-2.02.441.381.659.968 1.012 2.139zm.507 1.355l.51 1.518c.636.458 1.132.131 1.002-.234l-.501-1.49-1.011.206zm1.532 1.973c-.312.276-.727.082-1.541-.417l.023-.471-.683.777.567 1.644.021-.458c.963.578 1.191.689 1.613-1.075zm5.199-6.388l-8.819-5.217-2.044 1.167 8.859 5.138 2.004-1.088zm5.979-.943l-2 1.078v2.786l-3 1.688v-2.856l-2 1.078v8.362l7-3.985v-8.151zm-2.693 7.804l.35-.199v-1.717l-.35.199v1.717z" />
          </svg>
        );

      case "price-list":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            className={className}
            fill={fill ? fill : color1}
            style={style}
            viewBox="0 0 24 24"
          >
            <path d="M2 9.453v-9.453h9.352l10.648 10.625-3.794 3.794 1.849 4.733-12.34 4.848-5.715-14.547zm1.761 1.748l4.519 11.503 10.48-4.118-1.326-3.395-4.809 4.809-8.864-8.799zm-.761-10.201v8.036l9.622 9.552 7.963-7.962-9.647-9.626h-7.938zm12.25 8.293c-.415-.415-.865-.617-1.378-.617-.578 0-1.227.241-2.171.803-.682.411-1.118.585-1.456.585-.361 0-1.083-.409-.961-1.219.052-.345.25-.696.572-1.019.652-.652 1.544-.848 2.276-.107l.744-.744c-.476-.475-1.096-.792-1.761-.792-.566 0-1.125.228-1.663.677l-.626-.626-.698.699.653.652c-.569.826-.842 2.021.076 2.937 1.011 1.011 2.188.541 3.413-.232.6-.379 1.083-.563 1.475-.563.589.001 1.18.498 1.078 1.258-.052.386-.26.764-.621 1.122-.451.451-.904.679-1.347.679-.418 0-.747-.192-1.049-.462l-.739.739c.463.458 1.082.753 1.735.753.544 0 1.087-.201 1.612-.597l.54.538.697-.697-.52-.521c.743-.896 1.157-2.209.119-3.247zm-9.25-7.292c1.104 0 2 .896 2 2s-.896 2-2 2-2-.896-2-2 .896-2 2-2zm0 1c.552 0 1 .448 1 1s-.448 1-1 1-1-.448-1-1 .448-1 1-1z" />
          </svg>
        );
      case "task":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            className={className}
            fill={fill ? fill : color1}
            style={style}
            viewBox="0 0 24 24"
          >
            <path d="M7 14.729l.855-1.151c1 .484 1.635.852 2.76 1.654 2.113-2.399 3.511-3.616 6.106-5.231l.279.64c-2.141 1.869-3.709 3.949-5.967 7.999-1.393-1.64-2.322-2.326-4.033-3.911zm15-11.729v21h-20v-21h4.666l-2.666 2.808v16.192h16v-16.192l-2.609-2.808h4.609zm-3.646 4l-3.312-3.569v-.41c.001-1.668-1.352-3.021-3.021-3.021-1.667 0-3.021 1.332-3.021 3l.001.431-3.298 3.569h12.651zm-6.354-5c.553 0 1 .448 1 1s-.447 1-1 1-1-.448-1-1 .447-1 1-1z" />
          </svg>
        );

      case "medal":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            className={className}
            fill={fill ? fill : color1}
            style={style}
            viewBox="0 0 24 24"
          >
            <path d="M12 10c-3.865 0-7 3.134-7 7s3.135 7 7 7 7-3.134 7-7-3.135-7-7-7zm0 12c-2.762 0-5-2.239-5-5s2.238-5 5-5 5 2.239 5 5-2.238 5-5 5zm1.484-4.315l1.516-1.457-2.083-.287-.917-1.892-.917 1.892-2.083.287 1.516 1.457-.369 2.07 1.853-.992 1.854.992-.37-2.07zm.058-11.918l-.919-1.233 3.377-4.534h1.867l-4.325 5.767zm5.574-5.767l-4.952 6.603.939 1.26 5.897-7.863h-1.884zm-6.986 8h1.828l-5.958-8h-1.869l5.999 8zm-7.249-8h-1.881l6 8h1.881l-6-8z" />
          </svg>
        );
      case "percent":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            className={className}
            fill={fill ? fill : color1}
            style={style}
            viewBox="0 0 24 24"
          >
            <path d="M17.5 21a3.5 3.5 0 1 1 0-7 3.5 3.5 0 0 1 0 7zm0-2a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zm-11-9a3.5 3.5 0 1 1 0-7 3.5 3.5 0 0 1 0 7zm0-2a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zm12.571-4.485l1.414 1.414L4.93 20.485l-1.414-1.414L19.07 3.515z" />
          </svg>
        );

      case "discount":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            className={className}
            fill={fill ? fill : color1}
            style={style}
            viewBox="0 0 24 24"
          >
            <path d="M22.587 14.624l-9.584-9.624h-4.928c.106.357.167.701.173 1.025.985.123 1.752.956 1.752 1.975 0 1.104-.896 2-2 2s-2-.896-2-2c0-.843.524-1.561 1.262-1.855.01-.337-.067-.731-.227-1.145h-2.035v8.005l9.623 9.582 7.964-7.963zm-14.489-7.604c-.088.215-.207.408-.362.568-.231.239-.472.394-.719.495.045.511.461.917.983.917.552 0 1-.448 1-1 0-.517-.399-.929-.902-.98zm15.902 7.605l-9.375 9.375-10.625-10.579v-5.914c-1.123-.512-2.394-1.091-4-1.091v-1c1.611 0 2.92.511 4 .994v-2.41h2.492c-1.054-1.53-3.181-3-6.492-3v-1c4.093 0 6.603 2.055 7.661 4h5.757l10.582 10.625zm-6.997 1.731l.521.521-.698.697-.54-.538c-.525.396-1.068.597-1.612.597-.652 0-1.272-.295-1.734-.753l.738-.739c.303.27.631.462 1.049.462.443 0 .896-.228 1.347-.679.361-.359.569-.736.621-1.122.102-.76-.489-1.258-1.078-1.258-.392 0-.875.184-1.475.563-1.225.773-2.402 1.243-3.413.232-.918-.917-.645-2.112-.076-2.938l-.653-.652.698-.699.626.627c.538-.45 1.097-.677 1.663-.677.665 0 1.286.316 1.761.792l-.744.744c-.731-.742-1.624-.545-2.276.106-.322.323-.52.675-.572 1.02-.122.81.6 1.218.961 1.218.338 0 .774-.174 1.456-.584.944-.563 1.593-.804 2.171-.804.513 0 .963.202 1.378.617 1.038 1.038.624 2.351-.119 3.247z" />
          </svg>
        );
      case "flow":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            className={className}
            fill={fill ? fill : color1}
            style={style}
            viewBox="0 0 24 24"
            fillRule="evenodd"
            clipRule="evenodd"
          >
            <path d="M5.829 6c-.412 1.165-1.524 2-2.829 2-1.656 0-3-1.344-3-3s1.344-3 3-3c1.305 0 2.417.835 2.829 2h13.671c2.484 0 4.5 2.016 4.5 4.5s-2.016 4.5-4.5 4.5h-4.671c-.412 1.165-1.524 2-2.829 2-1.305 0-2.417-.835-2.829-2h-4.671c-1.38 0-2.5 1.12-2.5 2.5s1.12 2.5 2.5 2.5h13.671c.412-1.165 1.524-2 2.829-2 1.656 0 3 1.344 3 3s-1.344 3-3 3c-1.305 0-2.417-.835-2.829-2h-13.671c-2.484 0-4.5-2.016-4.5-4.5s2.016-4.5 4.5-4.5h4.671c.412-1.165 1.524-2 2.829-2 1.305 0 2.417.835 2.829 2h4.671c1.38 0 2.5-1.12 2.5-2.5s-1.12-2.5-2.5-2.5h-13.671zm6.171 5c.552 0 1 .448 1 1s-.448 1-1 1-1-.448-1-1 .448-1 1-1z" />
          </svg>
        );

      case "history":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            className={className}
            fill={fill ? fill : color1}
            style={style}
            viewBox="0 0 24 24"
          >
            <path d="M24 12c0 6.627-5.373 12-12 12s-12-5.373-12-12h2c0 5.514 4.486 10 10 10s10-4.486 10-10-4.486-10-10-10c-2.777 0-5.287 1.141-7.099 2.977l2.061 2.061-6.962 1.354 1.305-7.013 2.179 2.18c2.172-2.196 5.182-3.559 8.516-3.559 6.627 0 12 5.373 12 12zm-13-6v8h7v-2h-5v-6h-2z" />
          </svg>
        );

      case "activities":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            className={className}
            fill={fill ? fill : color1}
            style={style}
            viewBox="0 0 24 24"
          >
            <path d="M13 17h4v1h-4v-1zm0-1h4v-1h-4v1zm9-14v22h-20v-22h3c1.23 0 2.181-1.084 3-2h8c.82.916 1.771 2 3 2h3zm-11 1c0 .552.448 1 1 1 .553 0 1-.448 1-1s-.447-1-1-1c-.552 0-1 .448-1 1zm9 1h-4l-2 2h-3.897l-2.103-2h-4v18h16v-18zm-7 9h4v-1h-4v1zm0-2h4v-1h-4v1zm-6.5.077l.386-.355c.449.218.735.383 1.241.745.952-1.081 1.58-1.627 2.748-2.355l.125.288c-.963.841-1.669 1.777-2.686 3.6-.626-.738-1.044-1.208-1.814-1.923zm.098 5l.386-.355c.449.218.735.383 1.241.745.952-1.081 1.58-1.627 2.748-2.355l.125.289c-.963.841-1.669 1.777-2.686 3.6-.627-.739-1.045-1.209-1.814-1.924z" />
          </svg>
        );

      case "chat":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            className={className}
            fill={fill ? fill : color1}
            style={style}
            viewBox="0 0 24 24"
          >
            <path d="M10 3.002c4.411 0 8 2.849 8 6.35 0 3.035-3.029 6.311-7.925 6.311-1.58 0-2.718-.317-3.718-.561-.966.593-1.256.813-3.006 1.373.415-1.518.362-2.182.331-3.184-.837-1.001-1.682-2.069-1.682-3.939 0-3.501 3.589-6.35 8-6.35zm0-2.002c-5.281 0-10 3.526-10 8.352 0 1.711.615 3.391 1.705 4.695.047 1.527-.851 3.718-1.661 5.312 2.168-.391 5.252-1.258 6.649-2.115 1.181.289 2.312.421 3.382.421 5.903 0 9.925-4.038 9.925-8.313 0-4.852-4.751-8.352-10-8.352zm11.535 11.174c-.161.488-.361.961-.601 1.416 1.677 1.262 2.257 3.226.464 5.365-.021.745-.049 1.049.138 1.865-.892-.307-.979-.392-1.665-.813-2.127.519-4.265.696-6.089-.855-.562.159-1.145.278-1.74.364 1.513 1.877 4.298 2.897 7.577 2.1.914.561 2.933 1.127 4.352 1.385-.53-1.045-1.117-2.479-1.088-3.479 1.755-2.098 1.543-5.436-1.348-7.348zm-15.035-3.763c-.591 0-1.071.479-1.071 1.071s.48 1.071 1.071 1.071 1.071-.479 1.071-1.071-.48-1.071-1.071-1.071zm3.5 0c-.591 0-1.071.479-1.071 1.071s.48 1.071 1.071 1.071 1.071-.479 1.071-1.071-.48-1.071-1.071-1.071zm3.5 0c-.591 0-1.071.479-1.071 1.071s.48 1.071 1.071 1.071 1.071-.479 1.071-1.071-.48-1.071-1.071-1.071z" />
          </svg>
        );

      case "clock-out":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            className={className}
            fill={fill ? fill : color1}
            style={style}
            viewBox="0 0 24 24"
          >
            <path d="M6 14h6v-6c3.309 0 6 2.691 6 6s-2.691 6-6 6-6-2.691-6-6zm16 0c0 5.523-4.478 10-10 10s-10-4.477-10-10 4.478-10 10-10 10 4.477 10 10zm-2 0c0-4.411-3.589-8-8-8s-8 3.589-8 8 3.589 8 8 8 8-3.589 8-8zm-6-11.819v-2.181h-4v2.181c1.408-.238 2.562-.243 4 0zm6.679 3.554l1.321-1.321-1.414-1.414-1.407 1.407c.536.402 1.038.844 1.5 1.328z" />
          </svg>
        );

      case "clock-in":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            className={className}
            fill={fill ? fill : color1}
            style={style}
            viewBox="0 0 24 24"
          >
            <path d="M22 14c0 5.523-4.478 10-10 10s-10-4.477-10-10 4.478-10 10-10 10 4.477 10 10zm-2 0c0-4.411-3.589-8-8-8s-8 3.589-8 8 3.589 8 8 8 8-3.589 8-8zm-6-11.819v-2.181h-4v2.181c1.408-.238 2.562-.243 4 0zm6.679 3.554l1.321-1.321-1.414-1.414-1.407 1.407c.536.402 1.038.844 1.5 1.328zm-8.679 2.265v6h6c0-3.309-2.691-6-6-6z" />
          </svg>
        );

      case "attachment":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            className={className}
            fill={fill ? fill : color1}
            style={style}
            viewBox="0 0 24 24"
          >
            <path d="M21.586 10.461l-10.05 10.075c-1.95 1.949-5.122 1.949-7.071 0s-1.95-5.122 0-7.072l10.628-10.585c1.17-1.17 3.073-1.17 4.243 0 1.169 1.17 1.17 3.072 0 4.242l-8.507 8.464c-.39.39-1.024.39-1.414 0s-.39-1.024 0-1.414l7.093-7.05-1.415-1.414-7.093 7.049c-1.172 1.172-1.171 3.073 0 4.244s3.071 1.171 4.242 0l8.507-8.464c.977-.977 1.464-2.256 1.464-3.536 0-2.769-2.246-4.999-5-4.999-1.28 0-2.559.488-3.536 1.465l-10.627 10.583c-1.366 1.368-2.05 3.159-2.05 4.951 0 3.863 3.13 7 7 7 1.792 0 3.583-.684 4.95-2.05l10.05-10.075-1.414-1.414z" />
          </svg>
        );

      case "copy":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            className={className}
            fill={fill ? fill : color1}
            style={style}
            viewBox="0 0 24 24"
          >
            <path d="M18 6v-6h-18v18h6v6h18v-18h-6zm-12 10h-4v-14h14v4h-10v10zm16 6h-14v-14h14v14zm-3-8h-3v-3h-2v3h-3v2h3v3h2v-3h3v-2z" />
          </svg>
        );

      case "pencil":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            className={className}
            fill={fill ? fill : color1}
            style={style}
            viewBox="0 0 24 24"
          >
            <path d="M1.439 16.873l-1.439 7.127 7.128-1.437 16.873-16.872-5.69-5.69-16.872 16.872zm4.702 3.848l-3.582.724.721-3.584 2.861 2.86zm15.031-15.032l-13.617 13.618-2.86-2.861 10.825-10.826 2.846 2.846 1.414-1.414-2.846-2.846 1.377-1.377 2.861 2.86z" />
          </svg>
        );

      case "attach-file":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            className={className}
            fill={fill ? fill : color1}
            style={style}
            viewBox="0 0 24 24"
          >
            <path d="M12.37 5.379l-5.64 5.64c-.655.655-1.515.982-2.374.982-1.855 0-3.356-1.498-3.356-3.356 0-.86.327-1.721.981-2.375l5.54-5.539c.487-.487 1.125-.731 1.765-.731 2.206 0 3.338 2.686 1.765 4.259l-4.919 4.919c-.634.634-1.665.634-2.298 0-.634-.633-.634-1.664 0-2.298l3.97-3.97.828.828-3.97 3.97c-.178.177-.178.465 0 .642.177.178.465.178.642 0l4.919-4.918c1.239-1.243-.636-3.112-1.873-1.874l-5.54 5.54c-.853.853-.853 2.24 0 3.094.854.852 2.24.852 3.093 0l5.64-5.64.827.827zm.637-5.379c.409.609.635 1.17.729 2h7.264v11.543c0 4.107-6 2.457-6 2.457s1.518 6-2.638 6h-7.362v-8.062c-.63.075-1 .13-2-.133v10.195h10.189c3.163 0 9.811-7.223 9.811-9.614v-14.386h-9.993zm4.993 6h-3.423l-.793.793-.207.207h4.423v-1zm0 3h-6.423l-1 1h7.423v-1zm0 3h-9.423l-.433.433c-.212.213-.449.395-.689.567h10.545v-1z" />
          </svg>
        );

      case "id-card":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            className={className}
            fill={fill ? fill : color1}
            style={style}
            viewBox="0 0 24 24"
          >
            <path d="M22 8v12h-16v-12h16zm2-2h-20v16h20v-16zm-8 11.677v.323h-8v-.333c-.004-.89.035-1.398 1.059-1.634 1.123-.259 2.23-.491 1.697-1.473-1.577-2.911-.449-4.56 1.244-4.56 1.662 0 2.816 1.588 1.244 4.56-.518.976.551 1.208 1.697 1.473 1.028.237 1.063.748 1.059 1.644zm4-7.677h-3v2h3v-2zm0 3h-3v2h3v-2zm0 3h-3v2h3v-2zm2-12h-20v16h1v-15h19v-1zm-2-2h-20v16h1v-15h19v-1z" />
          </svg>
        );

      case "contact":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            className={className}
            fill={fill ? fill : color1}
            style={style}
            viewBox="0 0 24 24"
          >
            <path d="M17 18.597v.403h-10v-.417c-.004-1.112.044-1.747 1.324-2.043 1.402-.324 2.787-.613 2.121-1.841-1.972-3.637-.562-5.699 1.555-5.699 2.077 0 3.521 1.985 1.556 5.699-.647 1.22.688 1.51 2.121 1.841 1.284.297 1.328.936 1.323 2.057zm-1-14.597v2h3v16h-14v-16h3v-2h-5v20h18v-20h-5zm-6-4v6h4v-6h-4zm2 4c-.553 0-1-.448-1-1s.447-1 1-1 1 .448 1 1-.447 1-1 1z" />
          </svg>
        );

      case "opportunity":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            className={className}
            fill={fill ? fill : color1}
            style={style}
            viewBox="0 0 24 24"
          >
            <path d="M20.516 13.453l3.484-.891-1.932-7.562-3.526.891.196.753c-1.796.24-2.544-.226-4.459-1.226-.498-.257-.972-.418-1.408-.418-.592 0-1.108.268-1.503.714l-.491.552c-1.956-1.525-3.178-.405-4.505.084-.364.135-.793.185-1.087.202l.173-.662-3.526-.89-1.932 7.562 3.484.891.182-.695c.316.06 1.509.291 1.733.347-.649 1.055.01 2.357 1.199 2.495.226.545.741.932 1.34 1.003.225.544.736.928 1.332.997.33.815 1.305 1.267 2.232.863.352.354.841.537 1.356.537.703 0 1.349-.344 1.674-1.012.574-.12 1.052-.498 1.296-1.01.552-.115 1.031-.47 1.285-1.002.759-.154 1.378-.773 1.457-1.602.031-.312-.03-.624-.155-.91.289-.16 1.442-.647 1.886-.833l.215.822zm.686-6.996l1.338 5.24-1.165.298-1.366-5.237 1.193-.301zm-18.577 5.538l-1.165-.298 1.338-5.24 1.193.301-1.366 5.237zm3.766 2.484c-.294-.221-.331-.645-.08-.942l.61-.749c.249-.298.69-.363.986-.14.295.223.33.644.08.944l-.609.747c-.25.299-.693.361-.987.14zm1.336 1c-.296-.224-.337-.636-.086-.936l.616-.754c.25-.3.69-.363.984-.142.295.222.33.646.082.943l-.617.755c-.25.301-.682.356-.979.134zm1.336 1c-.295-.222-.333-.645-.082-.945l.609-.745c.251-.299.69-.364.986-.142.295.223.331.645.08.944l-.608.747c-.25.3-.691.361-.985.141zm2.93.108l-.61.75c-.251.302-.691.363-.986.142-.295-.222-.331-.645-.082-.943l.612-.751c.252-.298.693-.362.987-.139.296.221.332.644.079.941zm1.28 1.11c-.12.092-.266.138-.415.138-.16 0-.315-.069-.448-.176l.358-.441c.159-.187.269-.412.332-.65l.24.212c.251.285.218.694-.067.917zm3.873-3.017c-.289.222-.719.168-.967-.114l-1.944-1.669c-.16-.138-.37.107-.208.242l1.896 1.628c.248.285.217.696-.068.916-.276.218-.712.181-.969-.114l-1.491-1.308c-.161-.139-.37.102-.213.241l1.457 1.279c.249.285.211.686-.075.909-.28.218-.708.184-.96-.106l-.45-.402-.002-.225c-.089-.78-.711-1.352-1.449-1.434-.224-.547-.737-.93-1.335-.998-.218-.535-.726-.93-1.334-1-.397-.975-1.636-1.334-2.549-.679-.425-.133-1.852-.45-2.434-.564l.836-3.204c.783-.037 1.694-.132 2.902-.705.864-.411 1.278-.599 2.067-.013-.507.507-1.027.955-1.562 1.268-.48.28-.688.837-.531 1.419.181.668.856 1.343 1.96 1.343s2.924-1.014 3.279-1.502c1.472 1.391 2.902 2.684 4.143 3.796.35.39.285.776.001.996zm.526-2.537c-.837-.753-2.728-2.463-3.407-3.143-.289-.288-.691-.619-1.244-.619-.49 0-.878.267-1.128.468-.573.462-2.019 1.378-2.592.92 1.161-.754 2.208-1.943 3.192-3.063.24-.273.587-.219 1.1.044 2.153 1.125 3.007 1.666 5.538 1.394l.779 2.987c-.5.199-1.823.78-2.238 1.012z" />
          </svg>
        );

      case "prospect":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            className={className}
            fill={fill ? fill : color1}
            style={style}
            viewBox="0 0 24 24"
          >
            <path d="M21 4l-5-3h-8l-5 3-3 5 12 14 12-14.042-3-4.958zm-13.287 8.974l1.463 3.658-4.379-5.108 2.916 1.45zm6.668-4.974l.58 2.905-.038.095h-5.846l-.038-.095.58-2.905h4.762zm-.258 5l-2.123 5.307-2.123-5.307h4.246zm2.164-.026l2.881-1.44-4.332 5.069 1.451-3.629zm4.953-4.713l-4.334 2.168-.573-2.864 3.651-1.38 1.256 2.076zm-12.685-5.261h6.891l2.824 1.694-3.453 1.306h-5.64l-3.491-1.279 2.869-1.721zm-4.561 3.23l3.671 1.345-.571 2.856-4.329-2.152 1.229-2.049z" />
          </svg>
        );

      case "case":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            className={className}
            fill={fill ? fill : color1}
            style={style}
            viewBox="0 0 24 24"
          >
            <path d="M18.546 1h-13.069l-5.477 8.986v13.014h24v-13.014l-5.454-8.986zm-11.946 2h10.82l4.249 7h-19.335l4.266-7zm-4.6 18v-9h20v9h-20zm3-12l.607-1h12.786l.607 1h-14zm12.787-2h-11.572l.606-1h10.359l.607 1zm-1.215-2h-9.144l.607-1h7.931l.606 1zm-1.572 11h-6c-.553 0-1-.448-1-1s.447-1 1-1h6c.553 0 1 .448 1 1s-.447 1-1 1z" />
          </svg>
        );
      case "close-call":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            className={className}
            fill={fill ? fill : color1}
            style={style}
            viewBox="0 0 24 24"
          >
            <path d="M23.954 21.03l-9.184-9.095 9.092-9.174-2.832-2.807-9.09 9.179-9.176-9.088-2.81 2.81 9.186 9.105-9.095 9.184 2.81 2.81 9.112-9.192 9.18 9.1z" />
          </svg>
        );
      case "teams":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            className={className}
            fill={fill ? fill : color1}
            style={style}
            viewBox="0 0 24 24"
          >
            <path d="M17.997 18h-.998c0-1.552.06-1.775-.88-1.993-1.438-.332-2.797-.645-3.293-1.729-.18-.396-.301-1.048.155-1.907 1.021-1.929 1.277-3.583.702-4.538-.672-1.115-2.707-1.12-3.385.017-.576.968-.316 2.613.713 4.512.465.856.348 1.51.168 1.908-.49 1.089-1.836 1.4-3.262 1.728-.982.227-.92.435-.92 2.002h-.995l-.002-.623c0-1.259.1-1.985 1.588-2.329 1.682-.389 3.344-.736 2.545-2.209-2.366-4.365-.676-6.839 1.865-6.839 2.492 0 4.227 2.383 1.867 6.839-.775 1.464.824 1.812 2.545 2.209 1.49.344 1.589 1.072 1.589 2.333l-.002.619zm4.81-2.214c-1.289-.298-2.489-.559-1.908-1.657 1.77-3.342.47-5.129-1.4-5.129-1.265 0-2.248.817-2.248 2.325 0 1.269.574 2.175.904 2.925h1.048c-.17-.75-1.466-2.562-.766-3.736.412-.692 1.704-.693 2.114-.012.38.631.181 1.812-.534 3.161-.388.733-.28 1.301-.121 1.648.305.666.977.987 1.737 1.208 1.507.441 1.368.042 1.368 1.48h.997l.002-.463c0-.945-.074-1.492-1.193-1.75zm-22.805 2.214h.997c0-1.438-.139-1.039 1.368-1.48.761-.221 1.433-.542 1.737-1.208.159-.348.267-.915-.121-1.648-.715-1.349-.914-2.53-.534-3.161.41-.682 1.702-.681 2.114.012.7 1.175-.596 2.986-.766 3.736h1.048c.33-.75.904-1.656.904-2.925.001-1.509-.982-2.326-2.247-2.326-1.87 0-3.17 1.787-1.4 5.129.581 1.099-.619 1.359-1.908 1.657-1.12.258-1.194.805-1.194 1.751l.002.463z" />
          </svg>
        );

      case "changepassword":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            className={className}
            fill={fill ? fill : color1}
            style={style}
            viewBox="0 0 24 24"
          >
            <path d="M23.621 9.012c.247.959.379 1.964.379 3 0 6.623-5.377 11.988-12 11.988s-12-5.365-12-11.988c0-6.623 5.377-12 12-12 2.581 0 4.969.822 6.927 2.211l1.718-2.223 1.935 6.012h-6.58l1.703-2.204c-1.62-1.128-3.582-1.796-5.703-1.796-5.52 0-10 4.481-10 10 0 5.52 4.48 10 10 10 5.519 0 10-4.48 10-10 0-1.045-.161-2.053-.458-3h2.079zm-7.621 7.988h-8v-6h1v-2c0-1.656 1.344-3 3-3s3 1.344 3 3v2h1v6zm-5-8v2h2v-2c0-.552-.448-1-1-1s-1 .448-1 1z" />
          </svg>
        );
      case "down":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            className={className}
            fill={fill ? fill : color1}
            style={style}
            viewBox="0 0 24 24"
            clipRule="evenodd"
            fillRule="evenodd"
            strokeLinejoin="round"
            strokeMiterlimit="2"
          >
            <path
              d="m11.998 2c5.517 0 9.997 4.48 9.997 9.998 0 5.517-4.48 9.997-9.997 9.997-5.518 0-9.998-4.48-9.998-9.997 0-5.518 4.48-9.998 9.998-9.998zm0 1.5c-4.69 0-8.498 3.808-8.498 8.498s3.808 8.497 8.498 8.497 8.497-3.807 8.497-8.497-3.807-8.498-8.497-8.498zm4.845 6.711c.108-.141.157-.3.157-.456 0-.389-.306-.755-.749-.755h-8.501c-.445 0-.75.367-.75.755 0 .157.05.316.159.457 1.203 1.554 3.252 4.199 4.258 5.498.142.184.36.29.592.29.23 0 .449-.107.591-.291zm-7.564.289h5.446l-2.718 3.522z"
              fillRule="nonzero"
            />
          </svg>
        );

      case "up":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            className={className}
            fill={fill ? fill : color1}
            style={style}
            viewBox="0 0 24 24"
            clipRule="evenodd"
            fillRule="evenodd"
            strokeLinejoin="round"
            strokeMiterlimit="2"
          >
            <path
              d="m11.998 21.995c5.517 0 9.997-4.48 9.997-9.997 0-5.518-4.48-9.998-9.997-9.998-5.518 0-9.998 4.48-9.998 9.998 0 5.517 4.48 9.997 9.998 9.997zm0-1.5c-4.69 0-8.498-3.807-8.498-8.497s3.808-8.498 8.498-8.498 8.497 3.808 8.497 8.498-3.807 8.497-8.497 8.497zm4.845-6.711c.108.141.157.3.157.456 0 .389-.306.755-.749.755h-8.501c-.445 0-.75-.367-.75-.755 0-.157.05-.316.159-.457 1.203-1.554 3.252-4.199 4.258-5.498.142-.184.36-.29.592-.29.23 0 .449.107.591.291zm-7.564-.289h5.446l-2.718-3.522z"
              fillRule="nonzero"
            />
          </svg>
        );

      case "right":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            className={className}
            fill={fill ? fill : color1}
            style={style}
            viewBox="0 0 24 24"
            clipRule="evenodd"
            fillRule="evenodd"
            strokeLinejoin="round"
            strokeMiterlimit="2"
          >
            <path
              d="m2.009 12.002c0-5.517 4.48-9.997 9.998-9.997s9.998 4.48 9.998 9.997c0 5.518-4.48 9.998-9.998 9.998s-9.998-4.48-9.998-9.998zm1.5 0c0 4.69 3.808 8.498 8.498 8.498s8.498-3.808 8.498-8.498-3.808-8.497-8.498-8.497-8.498 3.807-8.498 8.497zm6.711-4.845c-.141-.108-.3-.157-.456-.157-.389 0-.755.306-.755.749v8.501c0 .445.367.75.755.75.157 0 .316-.05.457-.159 1.554-1.203 4.199-3.252 5.498-4.258.184-.142.29-.36.29-.592 0-.23-.107-.449-.291-.591zm.289 7.564v-5.446l3.523 2.718z"
              fillRule="nonzero"
            />
          </svg>
        );

      case "filter":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            className={className}
            fill={fill ? fill : color1}
            style={style}
            viewBox="0 0 24 24"
          >
            <path d="M19.479 2l-7.479 12.543v5.924l-1-.6v-5.324l-7.479-12.543h15.958zm3.521-2h-23l9 15.094v5.906l5 3v-8.906l9-15.094z" />
          </svg>
        );

      case "export":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            className={className}
            fill={fill ? fill : color1}
            style={style}
            viewBox="0 0 24 24"
            clipRule="evenodd"
            fillRule="evenodd"
          >
            <path d="M12 5c3.453 0 5.891 2.797 5.567 6.78 1.745-.046 4.433.751 4.433 3.72 0 1.93-1.57 3.5-3.5 3.5h-13c-1.93 0-3.5-1.57-3.5-3.5 0-2.797 2.479-3.833 4.433-3.72-.167-4.218 2.208-6.78 5.567-6.78zm0-2c-4.006 0-7.267 3.141-7.479 7.092-2.57.463-4.521 2.706-4.521 5.408 0 3.037 2.463 5.5 5.5 5.5h13c3.037 0 5.5-2.463 5.5-5.5 0-2.702-1.951-4.945-4.521-5.408-.212-3.951-3.473-7.092-7.479-7.092zm-4 10h3v-4h2v4h3l-4 4-4-4z" />
          </svg>
        );
      case "export-detail":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            className={className}
            fill={fill ? fill : color1}
            style={style}
            viewBox="0 0 24 24"
          >
            <path d="M14 19v-.083c-1.178.685-2.542 1.083-4 1.083-4.411 0-8-3.589-8-8s3.589-8 8-8c1.458 0 2.822.398 4 1.083v-2.245c-1.226-.536-2.576-.838-4-.838-5.522 0-10 4.477-10 10s4.478 10 10 10c1.424 0 2.774-.302 4-.838v-2.162zm4-9.592l2.963 2.592-2.963 2.592v-1.592h-8v-2h8v-1.592zm-2-4.408v4h-8v6h8v4l8-7-8-7z" />
          </svg>
        );

      case "import":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            className={className}
            fill={fill ? fill : color1}
            style={style}
            viewBox="0 0 24 24"
          >
            <path d="M12 5c3.453 0 5.891 2.797 5.567 6.78 1.745-.046 4.433.751 4.433 3.72 0 1.93-1.57 3.5-3.5 3.5h-13c-1.93 0-3.5-1.57-3.5-3.5 0-2.797 2.479-3.833 4.433-3.72-.167-4.218 2.208-6.78 5.567-6.78zm0-2c-4.006 0-7.267 3.141-7.479 7.092-2.57.463-4.521 2.706-4.521 5.408 0 3.037 2.463 5.5 5.5 5.5h13c3.037 0 5.5-2.463 5.5-5.5 0-2.702-1.951-4.945-4.521-5.408-.212-3.951-3.473-7.092-7.479-7.092zm4 10h-3v4h-2v-4h-3l4-4 4 4z" />
          </svg>
        );

      case "see-views":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            className={className}
            fill={fill ? fill : color1}
            style={style}
            viewBox="0 0 24 24"
            clipRule="evenodd"
            fillRule="evenodd"
            strokeLinejoin="round"
            strokeMiterlimit="2"
          >
            <path
              d="m11.3 13.7c0-.53-.47-1-1-1h-7.3c-.53 0-1 .47-1 1v5.3c0 .53.47 1 1 1h7.3c.53 0 1-.47 1-1zm10.7 0c0-.53-.47-1-1-1h-7.3c-.53 0-1 .47-1 1v5.3c0 .53.47 1 1 1h7.3c.53 0 1-.47 1-1zm-7.8.5h6.3v4.3h-6.3zm-10.7 0h6.3v4.3h-6.3zm18.5-9.2c0-.53-.47-1-1-1h-7.3c-.53 0-1 .47-1 1v5.3c0 .53.47 1 1 1h7.3c.53 0 1-.47 1-1zm-10.7 0c0-.53-.47-1-1-1h-7.3c-.53 0-1 .47-1 1v5.3c0 .53.47 1 1 1h7.3c.53 0 1-.47 1-1zm2.9.5h6.3v4.3h-6.3zm-10.7 0h6.3v4.3h-6.3z"
              fillRule="nonzero"
            />
          </svg>
        );

      case "kanban":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            className={className}
            fill={fill ? fill : color1}
            style={style}
            viewBox="0 0 24 24"
          >
            <path
              d="m11.3 13.7c0-.53-.47-1-1-1h-7.3c-.53 0-1 .47-1 1v5.3c0 .53.47 1 1 1h7.3c.53 0 1-.47 1-1zm10.7 0c0-.53-.47-1-1-1h-7.3c-.53 0-1 .47-1 1v5.3c0 .53.47 1 1 1h7.3c.53 0 1-.47 1-1zm-7.8.5h6.3v4.3h-6.3zm-10.7 0h6.3v4.3h-6.3zm18.5-9.2c0-.53-.47-1-1-1h-7.3c-.53 0-1 .47-1 1v5.3c0 .53.47 1 1 1h7.3c.53 0 1-.47 1-1zm-10.7 0c0-.53-.47-1-1-1h-7.3c-.53 0-1 .47-1 1v5.3c0 .53.47 1 1 1h7.3c.53 0 1-.47 1-1zm2.9.5h6.3v4.3h-6.3zm-10.7 0h6.3v4.3h-6.3z"
              fillRule="nonzero"
            />
          </svg>
        );

      case "double-right":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            className={className}
            fill={fill ? fill : color1}
            style={style}
            viewBox="0 0 24 24"
          >
            <path d="M0 3.795l2.995-2.98 11.132 11.185-11.132 11.186-2.995-2.981 8.167-8.205-8.167-8.205zm18.04 8.205l-8.167 8.205 2.995 2.98 11.132-11.185-11.132-11.186-2.995 2.98 8.167 8.206z" />
          </svg>
        );

      case "double-left":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            className={className}
            fill={fill ? fill : color1}
            style={{ ...style, transform: "scaleX(-1)" }}
            viewBox="0 0 24 24"
          >
            <path d="M0 3.795l2.995-2.98 11.132 11.185-11.132 11.186-2.995-2.981 8.167-8.205-8.167-8.205zm18.04 8.205l-8.167 8.205 2.995 2.98 11.132-11.185-11.132-11.186-2.995 2.98 8.167 8.206z" />
          </svg>
        );

      case "currency":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            className={className}
            fill={fill ? fill : color1}
            style={{ ...style }}
            viewBox="0 0 24 24"
          >
            <path d="M10.553 3.123c.47-.079.953-.123 1.447-.123 4.971 0 9 4.029 9 9 0 1.742-.5 3.363-1.359 4.738.226-.877.359-1.791.359-2.738 0-5.537-4.116-10.119-9.447-10.877zm12.447 8.877c0 .947-.133 1.861-.359 2.738.859-1.375 1.359-2.996 1.359-4.738 0-4.971-4.029-9-9-9-.494 0-.977.044-1.447.123 5.331.758 9.447 5.34 9.447 10.877zm-14-5c3.859 0 7 3.14 7 7s-3.141 7-7 7-7-3.14-7-7 3.141-7 7-7zm0-2c-4.971 0-9 4.029-9 9s4.029 9 9 9 9-4.029 9-9-4.029-9-9-9zm3.416 10.736c0-1.787-1.86-2.285-3.286-2.955-.864-.449-.757-1.525.483-1.597.691-.042 1.396.162 2.036.387l.302-1.372c-.756-.23-1.43-.335-2.035-.352v-.847h-.832v.889c-1.621.223-2.488 1.24-2.488 2.375 0 2.032 2.373 2.342 3.148 2.703 1.061.474.863 1.458-.094 1.675-.83.188-1.893-.14-2.688-.45l-.378 1.37c.744.385 1.637.591 2.5.605v.833h.832v-.877c1.381-.194 2.503-.956 2.5-2.387z" />
          </svg>
        );

      case "call-connect":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            className={className}
            fill={fill ? fill : color1}
            style={{ ...style }}
            viewBox="0 0 24 24"
            clipRule="evenodd"
            fillRule="evenodd"
          >
            <path d="M2.59 1.322l2.844-1.322 4.041 7.889-2.724 1.342c-.538 1.259 2.159 6.289 3.297 6.372.09-.058 2.671-1.328 2.671-1.328l4.11 7.932s-2.764 1.354-2.854 1.396c-.604.276-1.228.402-1.862.397-5.678-.043-12.143-10.564-12.113-17.454.011-2.351.777-4.279 2.59-5.224zm1.93 1.274l-1.023.504c-5.294 2.762 4.177 21.185 9.648 18.686l.972-.474-2.271-4.383-1.026.501c-3.163 1.547-8.262-8.219-5.055-9.938l1.007-.498-2.252-4.398zm8.98 6.404c.828 0 1.5.672 1.5 1.5s-.672 1.5-1.5 1.5-1.5-.672-1.5-1.5.672-1.5 1.5-1.5zm9 0c.828 0 1.5.672 1.5 1.5s-.672 1.5-1.5 1.5-1.5-.672-1.5-1.5.672-1.5 1.5-1.5zm-4.5 0c.828 0 1.5.672 1.5 1.5s-.672 1.5-1.5 1.5-1.5-.672-1.5-1.5.672-1.5 1.5-1.5z" />
          </svg>
        );

      case "lightbulb":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            className={className}
            fill={fill ? fill : color1}
            style={{ ...style }}
            viewBox="0 0 24 24"
          >
            <path d="M19 6.734c0 4.164-3.75 6.98-3.75 10.266h-1.992c.001-2.079.997-3.826 1.968-5.513.912-1.585 1.774-3.083 1.774-4.753 0-3.108-2.517-4.734-5.004-4.734-2.483 0-4.996 1.626-4.996 4.734 0 1.67.862 3.168 1.774 4.753.971 1.687 1.966 3.434 1.967 5.513h-1.991c0-3.286-3.75-6.103-3.75-10.266 0-4.343 3.498-6.734 6.996-6.734 3.502 0 7.004 2.394 7.004 6.734zm-4 11.766c0 .276-.224.5-.5.5h-5c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h5c.276 0 .5.224.5.5zm0 2c0 .276-.224.5-.5.5h-5c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h5c.276 0 .5.224.5.5zm-1.701 3.159c-.19.216-.465.341-.753.341h-1.093c-.288 0-.562-.125-.752-.341l-1.451-1.659h5.5l-1.451 1.659zm-2.182-11.123l3.633-5.536h-2.113l1.05-3.463-3.794 5.463h2.302l-1.078 3.536z" />
          </svg>
        );

      case "contact-ways":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            className={className}
            fill={fill ? fill : color1}
            style={{ ...style }}
            viewBox="0 0 24 24"
          >
            <path d="M15 7.494v-.663h3.813l-6.813-6.831-6.813 6.831h3.813v.664l-9 2.9 4.706 8.927 1.303-3.164c2.232 1.767 3.054 5.18 3.054 7.842h5.845999999999999c.252-2.662.573-5.858 3.083-7.843l1.303 3.164 4.705-8.926-9-2.901zm.821 3.325l-.821.597v-2.674l.821 2.077zm-3.821-7.984l1.986 1.991h-.986v8.404c-.778.847-1.447 1.776-2 2.781v-11.185h-.986l1.986-1.991zm-3 5.91v2.679c-.252-.203-.523-.405-.821-.604l.821-2.075zm-3.946 4.476l-.57 1.387-1.601-3.037 3.264-1.051-.457 1.151c1.833 1.006 4.015 2.656 5.256 4.445-.379.7-.7 1.437-.967 2.206-1.291-3.206-3.43-4.26-4.925-5.101zm13.891 0c-2.543 1.434-5.095 3.04-5.84 8.774h-1.921c.569-4.924 3.075-8.059 7.125-10.324l-.455-1.152 3.263 1.052-1.6 3.037-.572-1.387z" />
          </svg>
        );

      case "team":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            className={className}
            fill={fill ? fill : color1}
            style={{ ...style }}
            viewBox="0 0 24 24"
          >
            <path d="M17.997 18h-.998c0-1.552.06-1.775-.88-1.993-1.438-.332-2.797-.645-3.293-1.729-.18-.396-.301-1.048.155-1.907 1.021-1.929 1.277-3.583.702-4.538-.672-1.115-2.707-1.12-3.385.017-.576.968-.316 2.613.713 4.512.465.856.348 1.51.168 1.908-.49 1.089-1.836 1.4-3.262 1.728-.982.227-.92.435-.92 2.002h-.995l-.002-.623c0-1.259.1-1.985 1.588-2.329 1.682-.389 3.344-.736 2.545-2.209-2.366-4.365-.676-6.839 1.865-6.839 2.492 0 4.227 2.383 1.867 6.839-.775 1.464.824 1.812 2.545 2.209 1.49.344 1.589 1.072 1.589 2.333l-.002.619zm4.81-2.214c-1.289-.298-2.489-.559-1.908-1.657 1.77-3.342.47-5.129-1.4-5.129-1.265 0-2.248.817-2.248 2.325 0 1.269.574 2.175.904 2.925h1.048c-.17-.75-1.466-2.562-.766-3.736.412-.692 1.704-.693 2.114-.012.38.631.181 1.812-.534 3.161-.388.733-.28 1.301-.121 1.648.305.666.977.987 1.737 1.208 1.507.441 1.368.042 1.368 1.48h.997l.002-.463c0-.945-.074-1.492-1.193-1.75zm-22.805 2.214h.997c0-1.438-.139-1.039 1.368-1.48.761-.221 1.433-.542 1.737-1.208.159-.348.267-.915-.121-1.648-.715-1.349-.914-2.53-.534-3.161.41-.682 1.702-.681 2.114.012.7 1.175-.596 2.986-.766 3.736h1.048c.33-.75.904-1.656.904-2.925.001-1.509-.982-2.326-2.247-2.326-1.87 0-3.17 1.787-1.4 5.129.581 1.099-.619 1.359-1.908 1.657-1.12.258-1.194.805-1.194 1.751l.002.463z" />
          </svg>
        );

      case "category":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            className={className}
            fill={fill ? fill : color1}
            style={{ ...style }}
            viewBox="0 0 24 24"
          >
            <path d="M19 0h-14c-2.762 0-5 2.239-5 5v14c0 2.761 2.238 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-13 21c-1.656 0-3-1.343-3-3s1.344-3 3-3 3 1.343 3 3-1.344 3-3 3zm14-2h-9.101c.066-.323.101-.658.101-1s-.035-.677-.101-1h9.101c.552 0 1 .448 1 1s-.448 1-1 1zm2-7h-20v-7c0-1.654 1.346-3 3-3h14c1.654 0 3 1.346 3 3v7zm-12-2h-6l6-2.25v2.25z" />
          </svg>
        );
      case "alert":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            className={className}
            fill={fill ? fill : color1}
            style={{ ...style }}
            viewBox="0 0 24 24"
            fillRule="evenodd"
            clipRule="evenodd"
          >
            <path d="M24 17.98h-13l-7 5.02v-5.02h-4v-16.981h24v16.981zm-22-14.981v12.981h4v3.125l4.357-3.125h11.643v-12.981h-20zm10 8.501c.69 0 1.25.56 1.25 1.25s-.56 1.25-1.25 1.25-1.25-.56-1.25-1.25.56-1.25 1.25-1.25zm1-6.5v5h-2v-5h2z" />
          </svg>
        );

      case "subcategory":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            className={className}
            fill={fill ? fill : color1}
            style={{ ...style }}
            viewBox="0 0 24 24"
          >
            <path d="M19 0h-14c-2.762 0-5 2.239-5 5v14c0 2.761 2.238 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11.899 19h-3.101c-.552 0-1-.448-1-1s.448-1 1-1h3.101c-.066.323-.101.658-.101 1s.035.677.101 1zm4.899 2c-1.656 0-3-1.343-3-3s1.344-3 3-3 3 1.343 3 3-1.344 3-3 3zm8-2h-3.101c.066-.323.101-.658.101-1s-.035-.677-.101-1h3.101c.552 0 1 .448 1 1s-.448 1-1 1zm2-7h-20v-7c0-1.654 1.346-3 3-3h14c1.654 0 3 1.346 3 3v7zm-11-4.625l4-1.5v4.125h-4v-2.625zm-1 2.625h-6l6-2.25v2.25z" />
          </svg>
        );

      case "family":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            className={className}
            fill={fill ? fill : color1}
            style={{ ...style }}
            viewBox="0 0 24 24"
          >
            <path d="M19 0h-14c-2.762 0-5 2.239-5 5v14c0 2.761 2.238 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-5.898 19h-9.102c-.553 0-1-.448-1-1s.447-1 1-1h9.102c-.067.323-.102.658-.102 1s.035.677.102 1zm4.898 2c-1.656 0-3-1.343-3-3s1.344-3 3-3 3 1.343 3 3-1.344 3-3 3zm4-9h-20v-7c0-1.654 1.346-3 3-3h14c1.654 0 3 1.346 3 3v7zm-11-4.625l4-1.5v4.125h-4v-2.625zm9-3.375v6h-4v-4.5l4-1.5zm-10 6h-6l6-2.25v2.25z" />
          </svg>
        );

      case "priority":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            className={className}
            fill={fill ? fill : color1}
            style={{ ...style }}
            viewBox="0 0 24 24"
          >
            <path d="M6 3l-6 8h4v10h4v-10h4l-6-8zm16 6h-8v-2h8v2zm2-6h-10v2h10v-2zm-4 8h-6v2h6v-2zm-2 4h-4v2h4v-2zm-2 4h-2v2h2v-2z" />
          </svg>
        );

      case "user":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            className={className}
            fill={fill ? fill : color1}
            style={{ ...style }}
            viewBox="0 0 24 24"
          >
            <path d="M20.822 18.096c-3.439-.794-6.641-1.49-5.09-4.418 4.719-8.912 1.251-13.678-3.732-13.678-5.082 0-8.465 4.949-3.732 13.678 1.598 2.945-1.725 3.641-5.09 4.418-2.979.688-3.178 2.143-3.178 4.663l.005 1.241h1.995c0-3.134-.125-3.55 1.838-4.003 2.851-.657 5.543-1.278 6.525-3.456.359-.795.592-2.103-.338-3.815-2.058-3.799-2.578-7.089-1.423-9.026 1.354-2.275 5.426-2.264 6.767-.034 1.15 1.911.639 5.219-1.403 9.076-.91 1.719-.671 3.023-.31 3.814.99 2.167 3.707 2.794 6.584 3.458 1.879.436 1.76.882 1.76 3.986h1.995l.005-1.241c0-2.52-.199-3.975-3.178-4.663z" />
          </svg>
        );

      case "star":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            className={className}
            fill={fill ? fill : color1}
            style={{ ...style }}
            viewBox="0 0 24 24"
          >
            <path d="M12 5.173l2.335 4.817 5.305.732-3.861 3.71.942 5.27-4.721-2.524-4.721 2.525.942-5.27-3.861-3.71 5.305-.733 2.335-4.817zm0-4.586l-3.668 7.568-8.332 1.151 6.064 5.828-1.48 8.279 7.416-3.967 7.416 3.966-1.48-8.279 6.064-5.827-8.332-1.15-3.668-7.569z" />
          </svg>
        );

      case "company":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            className={className}
            fill={fill ? fill : color1}
            style={{ ...style }}
            viewBox="0 0 24 24"
          >
            <path d="M21 22h2v2h-22v-2h2v-22h18v22zm-10-3h-2v4h2v-4zm4 0h-2v4h2v-4zm4-17h-14v20h2v-5h10v5h2v-20zm-12 11h2v2h-2v-2zm4 0h2v2h-2v-2zm4 0h2v2h-2v-2zm-8-3h2v2h-2v-2zm4 0h2v2h-2v-2zm4 0h2v2h-2v-2zm-8-3h2v2h-2v-2zm4 0h2v2h-2v-2zm4 0h2v2h-2v-2zm-8-3h2v2h-2v-2zm4 0h2v2h-2v-2zm4 0h2v2h-2v-2z" />
          </svg>
        );

      case "key":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            className={className}
            fill={fill ? fill : color1}
            style={{ ...style }}
            viewBox="0 0 24 24"
            fillRule="evenodd"
            clipRule="evenodd"
          >
            <path d="M19 4v6.406l-3.753 3.741-6.463-6.462 3.7-3.685h6.516zm2-2h-12.388l1.497 1.5-4.171 4.167 9.291 9.291 4.161-4.193 1.61 1.623v-12.388zm-5 4c.552 0 1 .449 1 1s-.448 1-1 1-1-.449-1-1 .448-1 1-1zm0-1c-1.104 0-2 .896-2 2s.896 2 2 2 2-.896 2-2-.896-2-2-2zm6.708.292l-.708.708v3.097l2-2.065-1.292-1.74zm-12.675 9.294l-1.414 1.414h-2.619v2h-2v2h-2v-2.17l5.636-5.626-1.417-1.407-6.219 6.203v5h6v-2h2v-2h2l1.729-1.729-1.696-1.685z" />
          </svg>
        );

      case "lock":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            className={className}
            fill={fill ? fill : color1}
            style={{ ...style }}
            viewBox="0 0 24 24"
          >
            <path d="M23.621 9.012c.247.959.379 1.964.379 3 0 6.623-5.377 11.988-12 11.988s-12-5.365-12-11.988c0-6.623 5.377-12 12-12 2.581 0 4.969.822 6.927 2.211l1.718-2.223 1.935 6.012h-6.58l1.703-2.204c-1.62-1.128-3.582-1.796-5.703-1.796-5.52 0-10 4.481-10 10 0 5.52 4.48 10 10 10 5.519 0 10-4.48 10-10 0-1.045-.161-2.053-.458-3h2.079zm-7.621 7.988h-8v-6h1v-2c0-1.656 1.344-3 3-3s3 1.344 3 3v2h1v6zm-5-8v2h2v-2c0-.552-.448-1-1-1s-1 .448-1 1z" />
          </svg>
        );

      case "x-mark":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            className={className}
            fill={fill ? fill : color1}
            style={{ ...style }}
            viewBox="0 0 24 24"
          >
            <path d="M23 20.168l-8.185-8.187 8.185-8.174-2.832-2.807-8.182 8.179-8.176-8.179-2.81 2.81 8.186 8.196-8.186 8.184 2.81 2.81 8.203-8.192 8.18 8.192z" />
          </svg>
        );

      case "bell":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            className={className}
            fill={fill ? fill : color1}
            style={style}
            viewBox="0 0 24 24"
          >
            <path d="M15 21c0 1.598-1.392 3-2.971 3s-3.029-1.402-3.029-3h6zm.137-17.055c-.644-.374-1.042-1.07-1.041-1.82v-.003c.001-1.172-.938-2.122-2.096-2.122s-2.097.95-2.097 2.122v.003c.001.751-.396 1.446-1.041 1.82-4.668 2.709-1.985 11.715-6.862 13.306v1.749h20v-1.749c-4.877-1.591-2.193-10.598-6.863-13.306zm-3.137-2.945c.552 0 1 .449 1 1 0 .552-.448 1-1 1s-1-.448-1-1c0-.551.448-1 1-1zm-6.451 16c1.189-1.667 1.605-3.891 1.964-5.815.447-2.39.869-4.648 2.354-5.509 1.38-.801 2.956-.76 4.267 0 1.485.861 1.907 3.119 2.354 5.509.359 1.924.775 4.148 1.964 5.815h-12.903z" />
          </svg>
        );

      case "search":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            className={className}
            fill={fill ? fill : color1}
            style={{ ...style }}
            viewBox="0 0 24 24"
          >
            <path d="M23.809 21.646l-6.205-6.205c1.167-1.605 1.857-3.579 1.857-5.711 0-5.365-4.365-9.73-9.731-9.73-5.365 0-9.73 4.365-9.73 9.73 0 5.366 4.365 9.73 9.73 9.73 2.034 0 3.923-.627 5.487-1.698l6.238 6.238 2.354-2.354zm-20.955-11.916c0-3.792 3.085-6.877 6.877-6.877s6.877 3.085 6.877 6.877-3.085 6.877-6.877 6.877c-3.793 0-6.877-3.085-6.877-6.877z" />
          </svg>
        );

      case "thumb":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            className={className}
            fill={fill ? fill : color1}
            style={{ ...style }}
            viewBox="0 0 24 24"
          >
            <path d="M21.406 9.558c-1.21-.051-2.87-.278-3.977-.744.809-3.283 1.253-8.814-2.196-8.814-1.861 0-2.351 1.668-2.833 3.329-1.548 5.336-3.946 6.816-6.4 7.401v-.73h-6v12h6v-.904c2.378.228 4.119.864 6.169 1.746 1.257.541 3.053 1.158 5.336 1.158 2.538 0 4.295-.997 5.009-3.686.5-1.877 1.486-7.25 1.486-8.25 0-1.648-1.168-2.446-2.594-2.506zm-17.406 10.442h-2v-8h2v8zm15.896-5.583s.201.01 1.069-.027c1.082-.046 1.051 1.469.004 1.563l-1.761.099c-.734.094-.656 1.203.141 1.172 0 0 .686-.017 1.143-.041 1.068-.056 1.016 1.429.04 1.551-.424.053-1.745.115-1.745.115-.811.072-.706 1.235.109 1.141l.771-.031c.822-.074 1.003.825-.292 1.661-1.567.881-4.685.131-6.416-.614-2.239-.965-4.438-1.934-6.959-2.006v-6c3.264-.749 6.328-2.254 8.321-9.113.898-3.092 1.679-1.931 1.679.574 0 2.071-.49 3.786-.921 5.533 1.061.543 3.371 1.402 6.12 1.556 1.055.059 1.024 1.455-.051 1.584l-1.394.167s-.608 1.111.142 1.116z" />
          </svg>
        );

      case "shopping-cart":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            className={className}
            fill={fill ? fill : color1}
            style={style}
            viewBox="0 0 24 24"
          >
            <path d="M10.975 8l.025-.5c0-.517-.067-1.018-.181-1.5h5.993l-.564 2h-5.273zm-2.475 10c-.828 0-1.5.672-1.5 1.5 0 .829.672 1.5 1.5 1.5s1.5-.671 1.5-1.5c0-.828-.672-1.5-1.5-1.5zm11.305-15l-3.432 12h-10.428l-.455-1.083c-.323.049-.653.083-.99.083-.407 0-.805-.042-1.191-.114l1.306 3.114h13.239l3.474-12h1.929l.743-2h-4.195zm-6.305 15c-.828 0-1.5.671-1.5 1.5s.672 1.5 1.5 1.5 1.5-.671 1.5-1.5c0-.828-.672-1.5-1.5-1.5zm-4.5-10.5c0 2.485-2.018 4.5-4.5 4.5-2.484 0-4.5-2.015-4.5-4.5s2.016-4.5 4.5-4.5c2.482 0 4.5 2.015 4.5 4.5zm-2-.5h-2v-2h-1v2h-2v1h2v2h1v-2h2v-1z" />
          </svg>
        );

      case "cotization":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            className={className}
            fill={fill ? fill : color1}
            style={style}
            enableBackground="new 0 0 26 26"
            viewBox="0 0 26 26"
          >
            <g>
              <path d="M22,1H4C3.5859375,1,3.25,1.3359375,3.25,1.75v18.4013672   c0,0.0976563,0.0199585,0.1949463,0.0579224,0.2866211c0.0380249,0.0916138,0.0927124,0.1745605,0.1618042,0.2436523   l4.0986328,4.0986328c0.0690918,0.0690918,0.1520386,0.1237793,0.2436523,0.1618042   C7.9037476,24.9800415,8.0009766,25,8.0986328,25H22c0.4140625,0,0.75-0.3359375,0.75-0.75V1.75C22.75,1.3359375,22.4140625,1,22,1   z M7.3486328,22.4394531l-1.5380859-1.5380859h1.5380859V22.4394531z M21.25,23.5H8.8486328v-3.3486328   c0-0.4140625-0.3359375-0.75-0.75-0.75H4.75V2.5h16.5V23.5z" />
              <path d="M7.0493164,5.5H12.4375c0.2763672,0,0.5-0.2236328,0.5-0.5s-0.2236328-0.5-0.5-0.5H7.0493164   c-0.2763672,0-0.5,0.2236328-0.5,0.5S6.7729492,5.5,7.0493164,5.5z" />
              <path d="M7.0493164,7.5h2.6938477c0.2763672,0,0.5-0.2236328,0.5-0.5s-0.2236328-0.5-0.5-0.5H7.0493164   c-0.2763672,0-0.5,0.2236328-0.5,0.5S6.7729492,7.5,7.0493164,7.5z" />
              <path d="M10.875,7c0,0.2763672,0.2236328,0.5,0.5,0.5h3.25c0.2763672,0,0.5-0.2236328,0.5-0.5   s-0.2236328-0.5-0.5-0.5h-3.25C11.0986328,6.5,10.875,6.7236328,10.875,7z" />
              <path d="M7,15.75h12c0.2763672,0,0.5-0.2236328,0.5-0.5v-6c0-0.2763672-0.2236328-0.5-0.5-0.5H7   c-0.2763672,0-0.5,0.2236328-0.5,0.5v6C6.5,15.5263672,6.7236328,15.75,7,15.75z M16.5,11.03125v1h-1.625v-1H16.5z    M14.875,10.53125V9.75H16.5v0.78125H14.875z M14.875,13.53125v-1H16.5v1H14.875z M16.5,14.03125V14.75h-1.625v-0.71875H16.5z    M7.5,12.53125h6.875v1H7.5V12.53125z M17,12.53125h1.5v1H17V12.53125z M18.5,12.03125H17v-1h1.5V12.03125z M14.375,12.03125H7.5   v-1h6.875V12.03125z M7.5,14.03125h6.875V14.75H7.5V14.03125z M17,14.75v-0.71875h1.5V14.75H17z M18.5,10.53125H17V9.75h1.5   V10.53125z M14.375,9.75v0.78125H7.5V9.75H14.375z" />
              <path d="M16.8173828,16.3496094c-0.8711548,0-1.6316528,0.4620361-2.0640869,1.1503906h-0.7039795   c-0.2763672,0-0.5,0.2236328-0.5,0.5s0.2236328,0.5,0.5,0.5h0.3552246C14.3928223,18.5968628,14.375,18.6920166,14.375,18.7919922   c0,1.3466797,1.0957031,2.4423828,2.4423828,2.4423828s2.4418945-1.0957031,2.4418945-2.4423828   S18.1640625,16.3496094,16.8173828,16.3496094z M16.8173828,20.734375c-1.0708008,0-1.9423828-0.8710938-1.9423828-1.9423828   c0-0.0999756,0.0148926-0.1960449,0.029541-0.2919922h0.3500977c-0.0177002,0.0949707-0.029541,0.1920166-0.029541,0.2919922   c0,0.8779297,0.7143555,1.5917969,1.5922852,1.5917969s1.5917969-0.7138672,1.5917969-1.5917969   s-0.7138672-1.5927734-1.5917969-1.5927734c-0.3452148,0-0.6627808,0.1132813-0.9238892,0.3007813h-0.515686   c0.355896-0.3961792,0.8665161-0.6503906,1.4395752-0.6503906c1.0708008,0,1.9418945,0.8710938,1.9418945,1.9423828   S17.8881836,20.734375,16.8173828,20.734375z M16.75,18.5c0.2763672,0,0.5-0.2236328,0.5-0.5   c0-0.0823975-0.0246582-0.1567993-0.0598755-0.2252808c0.4172363,0.1537476,0.7190552,0.5469971,0.7190552,1.0172729   c0,0.6015625-0.4897461,1.0917969-1.0917969,1.0917969s-1.0922852-0.4902344-1.0922852-1.0917969   c0-0.1035156,0.0320435-0.1970215,0.059082-0.2919922H16.75z" />
              <path d="M12.4375,17.5H7.0493164c-0.2763672,0-0.5,0.2236328-0.5,0.5s0.2236328,0.5,0.5,0.5H12.4375   c0.2763672,0,0.5-0.2236328,0.5-0.5S12.7138672,17.5,12.4375,17.5z" />
            </g>
          </svg>
        );

      case "taxes":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            className={className}
            fill={fill ? fill : color1}
            style={style}
            viewBox="0 0 24 24"
          >
            <path d="M18 11c2.757 0 5 2.243 5 5s-2.243 5-5 5-5-2.243-5-5 2.243-5 5-5zm0-1c-3.313 0-6 2.687-6 6s2.687 6 6 6 6-2.687 6-6-2.687-6-6-6zm.5 8.474v.526h-.5v-.499c-.518-.009-1.053-.132-1.5-.363l.228-.822c.478.186 1.114.383 1.612.27.574-.13.692-.721.057-1.005-.465-.217-1.889-.402-1.889-1.622 0-.681.52-1.292 1.492-1.425v-.534h.5v.509c.362.01.768.073 1.221.21l-.181.824c-.384-.135-.808-.257-1.222-.232-.744.043-.81.688-.29.958.856.402 1.972.7 1.972 1.773.001.858-.672 1.315-1.5 1.432zm-7.911-5.474h-2.589v-2h3.765c-.484.602-.881 1.274-1.176 2zm-.589 3h-2v-2h2.264c-.166.641-.264 1.309-.264 2zm2.727-6h-4.727v-2h7v.589c-.839.341-1.604.822-2.273 1.411zm2.273-6h-7v-2h7v2zm0 3h-7v-2h7v2zm-4.411 12h-2.589v-2h2.069c.088.698.264 1.369.52 2zm-10.589-11h7v2h-7v-2zm0 3h7v2h-7v-2zm12.727 11h-4.727v-2h3.082c.438.753.994 1.428 1.645 2zm-12.727-5h7v2h-7v-2zm0 3h7v2h-7v-2zm0-6h7v2h-7v-2z" />
          </svg>
        );

      case "roles":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            className={className}
            fill={fill ? fill : color1}
            style={style}
            viewBox="0 0 24 24"
          >
            <path d="M17.996 23h-17.99l-.005-1.167c-.006-1.646-.011-3.198 2.512-3.782 1.837-.426 3.263-1.231 3.634-2.052.154-.342.127-.696-.082-1.082-1.72-3.185-2.044-5.985-.911-7.884.77-1.292 2.173-2.033 3.847-2.033 1.662 0 3.055.73 3.822 2.002 1.132 1.876.818 4.685-.884 7.91-.206.391-.229.75-.071 1.095.374.819 1.796 1.622 3.62 2.044 2.526.585 2.519 2.147 2.512 3.801l-.004 1.148zm-16.994-1h15.998v-.15c.008-1.799-.074-2.44-1.736-2.825-.818-.189-3.543-.935-4.306-2.601-.287-.63-.254-1.314.097-1.979 1.531-2.902 1.855-5.362.912-6.926-.59-.979-1.644-1.519-2.966-1.519-1.333 0-2.394.549-2.988 1.545-.946 1.585-.614 4.034.932 6.896.357.661.396 1.342.113 1.969-.755 1.673-3.497 2.425-4.32 2.615-1.661.385-1.743 1.021-1.737 2.802l.001.173zm13.147-11c.364-.902.642-1.884.618-2.85-.495-.718-.766-1.6-.766-2.502 0-2.574 2.243-4.669 5-4.669s5 2.095 5 4.669c0 2.237-1.898 4.651-4.966 4.651-.471 0-.953-.058-1.439-.174-.604.271-2.185.932-3.447.875zm4.852-9.021c-2.206 0-4 1.646-4 3.669 0 .747.563 1.95.749 2.21.011.339-.03 1.382-.269 2.032.745-.211 1.605-.596 1.952-.795.492.134 1.151.204 1.602.204 2.449 0 3.966-1.895 3.966-3.651 0-2.023-1.794-3.669-4-3.669zm-.001.374l-.976 2.014-2.217.305 1.615 1.552-.395 2.204 1.973-1.057 1.973 1.056-.393-2.203 1.613-1.552-2.217-.305-.976-2.014zm-.5 3.52l-.512-.491.702-.097.31-.639.31.639.703.097-.511.491.125.699-.627-.335-.625.334.125-.698z" />
          </svg>
        );

      case "note":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            className={className}
            fill={fill ? fill : color1}
            style={style}
            viewBox="0 0 24 24"
          >
            <path d="M15.812 4.819c-.33-.341-.312-.877.028-1.207l3.469-3.365c.17-.164.387-.247.603-.247.219 0 .438.085.604.257l-4.704 4.562zm-5.705 8.572c-.07.069-.107.162-.107.255 0 .194.158.354.354.354.089 0 .178-.033.247-.1l.583-.567-.493-.509-.584.567zm4.924-6.552l-1.994 1.933c-1.072 1.039-1.619 2.046-2.124 3.451l.881.909c1.419-.461 2.442-.976 3.514-2.016l1.994-1.934-2.271-2.343zm5.816-5.958l-5.137 4.982 2.586 2.671 5.138-4.98c.377-.366.566-.851.566-1.337 0-1.624-1.968-2.486-3.153-1.336zm-11.847 12.119h-4v1h4v-1zm9-1.35v1.893c0 4.107-6 2.457-6 2.457s1.518 6-2.638 6h-7.362v-20h12.629l2.062-2h-16.691v24h10.189c3.163 0 9.811-7.223 9.811-9.614v-4.687l-2 1.951z" />
          </svg>
        );

      case "clean":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            className={className}
            fill={fill ? fill : color1}
            style={style}
            viewBox="0 0 24 24"
          >
            <path d="M5.662 23l-5.369-5.365c-.195-.195-.293-.45-.293-.707 0-.256.098-.512.293-.707l14.929-14.928c.195-.194.451-.293.707-.293.255 0 .512.099.707.293l7.071 7.073c.196.195.293.451.293.708 0 .256-.097.511-.293.707l-11.216 11.219h5.514v2h-12.343zm3.657-2l-5.486-5.486-1.419 1.414 4.076 4.072h2.829zm6.605-17.581l-10.677 10.68 5.658 5.659 10.676-10.682-5.657-5.657z" />
          </svg>
        );

      case "add-list":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            className={className}
            fill={fill ? fill : color1}
            style={style}
            fillRule="evenodd"
            clipRule="evenodd"
            strokeLinejoin="round"
            strokeMiterlimit="2"
            viewBox="0 0 22 22"
          >
            <path
              d="m17.5 11c2.484 0 4.5 2.016 4.5 4.5s-2.016 4.5-4.5 4.5-4.5-2.016-4.5-4.5 2.016-4.5 4.5-4.5zm.5 4v-1.5c0-.265-.235-.5-.5-.5s-.5.235-.5.5v1.5h-1.5c-.265 0-.5.235-.5.5s.235.5.5.5h1.5v1.5c0 .265.235.5.5.5s.5-.235.5-.5c0-.592 0-1.5 0-1.5h1.5c.265 0 .5-.235.5-.5s-.235-.5-.5-.5c-.592 0-1.5 0-1.5 0zm-6.479 1c.043.522.153 1.025.321 1.5h-9.092c-.414 0-.75-.336-.75-.75s.336-.75.75-.75zm1.106-4c-.328.456-.594.96-.785 1.5h-9.092c-.414 0-.75-.336-.75-.75s.336-.75.75-.75zm7.373-3.25c0-.414-.336-.75-.75-.75h-16.5c-.414 0-.75.336-.75.75s.336.75.75.75h16.5c.414 0 .75-.336.75-.75zm0-4c0-.414-.336-.75-.75-.75h-16.5c-.414 0-.75.336-.75.75s.336.75.75.75h16.5c.414 0 .75-.336.75-.75z"
              fillRule="nonzero"
            />
          </svg>
        );

      case "timerunningout":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            className={className}
            fill={fill ? fill : color1}
            style={style}
            viewBox="0 0 24 24"
          >
            <path d="M18.513 7.119c.958-1.143 1.487-2.577 1.487-4.036v-3.083h-16v3.083c0 1.459.528 2.892 1.487 4.035l3.087 3.68c.566.677.57 1.625.009 2.306l-3.13 3.794c-.937 1.136-1.453 2.555-1.453 3.995v3.107h16v-3.107c0-1.44-.517-2.858-1.453-3.994l-3.13-3.794c-.562-.681-.558-1.629.009-2.306l3.087-3.68zm-.513-4.12c0 1.101-.363 2.05-1.02 2.834l-.978 1.167h-8.004l-.978-1.167c-.66-.785-1.02-1.736-1.02-2.834h12zm-.996 15.172c.652.791.996 1.725.996 2.829h-1.061c-1.939-2-4.939-2-4.939-2s-3 0-4.939 2h-1.061c0-1.104.344-2.039.996-2.829l3.129-3.793c.342-.415.571-.886.711-1.377h.164v1h2v-1h.163c.141.491.369.962.711 1.376l3.13 3.794zm-6.004-1.171h2v1h-2v-1zm0-2h2v1h-2v-1z" />
          </svg>
        );

      case "timeover":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            className={className}
            fill={fill ? fill : color1}
            style={style}
            viewBox="0 0 24 24"
          >
            <path d="M18.513 7.119c.958-1.143 1.487-2.577 1.487-4.036v-3.083h-16v3.083c0 1.459.528 2.892 1.487 4.035l3.086 3.68c.567.677.571 1.625.009 2.306l-3.13 3.794c-.936 1.136-1.452 2.555-1.452 3.995v3.107h16v-3.107c0-1.44-.517-2.858-1.453-3.994l-3.13-3.794c-.562-.681-.558-1.629.009-2.306l3.087-3.68zm-4.639 7.257l3.13 3.794c.652.792.996 1.726.996 2.83h-1.061c-.793-2.017-4.939-5-4.939-5s-4.147 2.983-4.94 5h-1.06c0-1.104.343-2.039.996-2.829l3.129-3.793c1.167-1.414 1.159-3.459-.019-4.864l-3.086-3.681c-.66-.785-1.02-1.736-1.02-2.834h12c0 1.101-.363 2.05-1.02 2.834l-3.087 3.68c-1.177 1.405-1.185 3.451-.019 4.863z" />
          </svg>
        );

      case "trash":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            className={className}
            fill={fill ? fill : color1}
            style={style}
            viewBox="0 0 24 24"
          >
            <path d="M9 19c0 .552-.448 1-1 1s-1-.448-1-1v-10c0-.552.448-1 1-1s1 .448 1 1v10zm4 0c0 .552-.448 1-1 1s-1-.448-1-1v-10c0-.552.448-1 1-1s1 .448 1 1v10zm4 0c0 .552-.448 1-1 1s-1-.448-1-1v-10c0-.552.448-1 1-1s1 .448 1 1v10zm5-17v2h-20v-2h5.711c.9 0 1.631-1.099 1.631-2h5.315c0 .901.73 2 1.631 2h5.712zm-3 4v16h-14v-16h-2v18h18v-18h-2z" />
          </svg>
        );
      case "link":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            className={className}
            fill={fill ? fill : color1}
            style={style}
            viewBox="0 0 24 24"
          >
            <path d="M21 13v10h-21v-19h12v2h-10v15h17v-8h2zm3-12h-10.988l4.035 4-6.977 7.07 2.828 2.828 6.977-7.07 4.125 4.172v-11z" />
          </svg>
        );
      case "print":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            className={className}
            fill={fill ? fill : color1}
            style={style}
            viewBox="0 0 24 24"
          >
            <path d="M16 17h-8v-1h8v1zm8-12v13h-4.048c-.404 2.423-3.486 6-6.434 6h-9.518v-6h-4v-13h4v-5h16v5h4zm-18 0h12v-3h-12v3zm12 9h-12v8h6.691c3.469 0 2-3.352 2-3.352s3.309 1.594 3.309-2v-2.648zm4-7h-20v9h2v-4h16v4h2v-9zm-9 11h-5v1h5v-1zm7.5-10c-.276 0-.5.224-.5.5s.224.5.5.5.5-.224.5-.5-.224-.5-.5-.5z" />
          </svg>
        );
      case "incident":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            className={className}
            fill={fill ? fill : color1}
            style={style}
            viewBox="0 0 24 24"
            clipRule="evenodd"
            fillRule="evenodd"
            strokeLinejoin="round"
            strokeMiterlimit="2"
          >
            <path
              d="m2.095 19.886 9.248-16.5c.133-.237.384-.384.657-.384.272 0 .524.147.656.384l9.248 16.5c.064.115.096.241.096.367 0 .385-.309.749-.752.749h-18.496c-.44 0-.752-.36-.752-.749 0-.126.031-.252.095-.367zm1.935-.384h15.939l-7.97-14.219zm7.972-6.497c-.414 0-.75.336-.75.75v3.5c0 .414.336.75.75.75s.75-.336.75-.75v-3.5c0-.414-.336-.75-.75-.75zm-.002-3c.552 0 1 .448 1 1s-.448 1-1 1-1-.448-1-1 .448-1 1-1z"
              fillRule="nonzero"
            />
          </svg>
        );
        case "producción":
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={width}
                    height={height}
                    className={className}
                    fill={fill ? fill : color1}
                    style={style}
                    viewBox= "0 -960 960 960"
                    clipRule="evenodd"
                    fillRule="evenodd"
                    strokeLinejoin="round"
                    strokeMiterlimit="2"
                >
                    <path xmlns="http://www.w3.org/2000/svg" d="M100-100v-447.54l240-102.07v79.23l200-80V-540h320v440H100Zm60-60h640v-320H480v-82l-200 80v-78l-120 53v347Zm284.62-89.23h70.76v-141.54h-70.76v141.54Zm-160 0h70.76v-141.54h-70.76v141.54Zm320 0h70.76v-141.54h-70.76v141.54ZM860-540H697.69l40-304.61h84.62L860-540ZM160-160h640-640Z" />
                </svg>
            );
        case "download":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={width}
                height={height}
                fill={fill ? fill : color1}
                className={className}
                style={style}
                viewBox="0 -960 960 960"
              >
                <path d="M480-320 280-520l56-58 104 104v-326h80v326l104-104 56 58-200 200ZM240-160q-33 0-56.5-23.5T160-240v-120h80v120h480v-120h80v120q0 33-23.5 56.5T720-160H240Z" />
              </svg>
            );
      default:
        return (
          <svg
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            fillRule="evenodd"
            clipRule="evenodd"
            strokeLinejoin="round"
            strokeMiterlimit="2"
            width={width}
            height={height}
            fill={fill ? fill : color1}
            style={style}
          >
            <path d="m11.322 2.923c.126-.259.39-.423.678-.423.289 0 .552.164.678.423.974 1.998 2.65 5.44 2.65 5.44s3.811.524 6.022.829c.403.055.65.396.65.747 0 .19-.072.383-.231.536-1.61 1.538-4.382 4.191-4.382 4.191s.677 3.767 1.069 5.952c.083.462-.275.882-.742.882-.122 0-.244-.029-.355-.089-1.968-1.048-5.359-2.851-5.359-2.851s-3.391 1.803-5.359 2.851c-.111.06-.234.089-.356.089-.465 0-.825-.421-.741-.882.393-2.185 1.07-5.952 1.07-5.952s-2.773-2.653-4.382-4.191c-.16-.153-.232-.346-.232-.535 0-.352.249-.694.651-.748 2.211-.305 6.021-.829 6.021-.829s1.677-3.442 2.65-5.44zm.678 2.033-2.361 4.792-5.246.719 3.848 3.643-.948 5.255 4.707-2.505 4.707 2.505-.951-5.236 3.851-3.662-5.314-.756z" />
          </svg>
        );
    }
  };

  return useMemo(
    () => selectIcon(iconName),
    [iconName, className, fill]
  );
}
